/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * JM 3.0 API - Mobilitydata Service
 * This API was created to be used internally by EcoLibro as part of JM 3.0, a project aiming to improve data availability for internally produced mobility analyses. Possible uses include a partly automated data transfer to QGIS for analytical purposes and a fully automated data transfer to a standalone application for future clients. The JM 3.0 API offers the following functions:
 *
 * OpenAPI spec version: 0.0.2
 * Contact: dirk.mischke@cleverroute.net
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = import.meta.env.VITE_CLEVERREACH_API_BASE_URL +		
"/jmapi/v1".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * Adressen Schema, wird zurückgegeben wenn eine erfolgreiche get-Request für Adressen gesendet wurde
 * @export
 * @interface Adress
 */
export interface Adress {
    /**
     * 
     * @type {string}
     * @memberof Adress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Adress
     */
    houseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Adress
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Adress
     */
    district?: string;
    /**
     * 
     * @type {Point}
     * @memberof Adress
     */
    geo?: Point;
}
/**
 * 
 * @export
 * @interface AdressWithId
 */
export interface AdressWithId extends Adress {
    /**
     * 
     * @type {number}
     * @memberof AdressWithId
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface AdressesBatchBody
 */
export interface AdressesBatchBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof AdressesBatchBody
     */
    addressIds: Array<number>;
}
/**
 * 
 * @export
 * @interface AdressesBody
 */
export interface AdressesBody extends AdressWithId {
    /**
     * 
     * @type {boolean}
     * @memberof AdressesBody
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface AdressesCheckusageBody
 */
export interface AdressesCheckusageBody {
    /**
     * List of address IDs to check
     * @type {Array<number>}
     * @memberof AdressesCheckusageBody
     */
    addressIds: Array<number>;
    /**
     * Office ID to exclude from the check
     * @type {number}
     * @memberof AdressesCheckusageBody
     */
    excludeOfficeId: number;
}
/**
 * 
 * @export
 * @interface CRExportView
 */
export interface CRExportView {
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    MA_ID?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pathId?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    officeId?: number;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    startStrae?: string;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    startOrtschaft?: string;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    startPLZ?: string;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pKWEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pedelecEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fahrradEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVFahrradEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    autoOeVEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eAutoEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fussWegEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeScooterEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiOeVEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterOeVEntfernung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pKWZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pedelecZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fahrradZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVFahrradZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    autoOeVZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eAutoZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fussWegZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeScooterZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiOeVZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterOeVZeit?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pKWKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pedelecKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fahrradKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVFahrradKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    autoOeVKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eAutoKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fussWegKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeScooterKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiOeVKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterOeVKosten?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pKWCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pedelecCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fahrradCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVFahrradCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    autoOeVCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eAutoCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fussWegCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeScooterCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiOeVCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterOeVCO2?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pKWBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pedelecBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fahrradBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVFahrradBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    autoOeVBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eAutoBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fussWegBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeScooterBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiOeVBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterOeVBewegung?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pKWMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    pedelecMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fahrradMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    oeVMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeAndRideMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    parkAndRideMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eAutoMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    fussWegMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    bikeScooterMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    taxiAndRideMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterMobscore?: number;
    /**
     * 
     * @type {number}
     * @memberof CRExportView
     */
    eScooterAndRideMobscore?: number;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    kostenEffektivstesVM?: string;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    zeitEffektivstesVM?: string;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    cO2EffektivstesVM?: string;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    bewegungsEffektivstesVM?: string;
    /**
     * 
     * @type {string}
     * @memberof CRExportView
     */
    nutzenEffektivsteVM?: string;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company extends CompanyWithoutId {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface CompanyWithoutId
 */
export interface CompanyWithoutId {
    /**
     * 
     * @type {string}
     * @memberof CompanyWithoutId
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface DownloadExcelBody
 */
export interface DownloadExcelBody {
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof DownloadExcelBody
     */
    data?: Array<Array<string>>;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof DownloadExcelBody
     */
    styling?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GeoJSONFeature
 */
export interface GeoJSONFeature {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeature
     */
    type?: GeoJSONFeature.TypeEnum;
    /**
     * 
     * @type {Geometry}
     * @memberof GeoJSONFeature
     */
    geometry?: Geometry;
    /**
     * 
     * @type {any}
     * @memberof GeoJSONFeature
     */
    properties?: any;
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeature
     */
    id?: string;
}

/**
 * @export
 * @namespace GeoJSONFeature
 */
export namespace GeoJSONFeature {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Feature = <any> 'Feature'
    }
}
/**
 * 
 * @export
 * @interface GeoJSONFeatureCollection
 */
export interface GeoJSONFeatureCollection {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeatureCollection
     */
    type?: GeoJSONFeatureCollection.TypeEnum;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof GeoJSONFeatureCollection
     */
    features?: Array<GeoJSONFeature>;
    /**
     * 
     * @type {GeoJSONFeatureCollectionMetadata}
     * @memberof GeoJSONFeatureCollection
     */
    metadata?: GeoJSONFeatureCollectionMetadata;
}

/**
 * @export
 * @namespace GeoJSONFeatureCollection
 */
export namespace GeoJSONFeatureCollection {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FeatureCollection = <any> 'FeatureCollection'
    }
}
/**
 * 
 * @export
 * @interface GeoJSONFeatureCollectionMetadata
 */
export interface GeoJSONFeatureCollectionMetadata {
    /**
     * 
     * @type {number}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    totalFeatures?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    returnedFeatures?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    offset?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    hasMore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    simplificationApplied?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    simplificationTolerance?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoJSONFeatureCollectionMetadata
     */
    bbox?: Array<number>;
}
/**
 * 
 * @export
 * @interface GeoPackageFile
 */
export interface GeoPackageFile {
    /**
     * 
     * @type {number}
     * @memberof GeoPackageFile
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageFile
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoPackageFile
     */
    fileName?: string;
    /**
     * 
     * @type {Date}
     * @memberof GeoPackageFile
     */
    uploadDate?: Date;
    /**
     * Size of the file in bytes
     * @type {number}
     * @memberof GeoPackageFile
     */
    fileSize?: number;
    /**
     * Number of layers in the GeoPackage
     * @type {number}
     * @memberof GeoPackageFile
     */
    layerCount?: number;
}
/**
 * 
 * @export
 * @interface GeoPackageFileValidation
 */
export interface GeoPackageFileValidation {
    /**
     * 
     * @type {string}
     * @memberof GeoPackageFileValidation
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageFileValidation
     */
    fileSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeoPackageFileValidation
     */
    isValid?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeoPackageFileValidation
     */
    validationMessages?: Array<string>;
    /**
     * 
     * @type {Array<LayerValidation>}
     * @memberof GeoPackageFileValidation
     */
    layers?: Array<LayerValidation>;
}
/**
 * 
 * @export
 * @interface GeoPackageLayer
 */
export interface GeoPackageLayer {
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    geopackageId?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoPackageLayer
     */
    layerName?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoPackageLayer
     */
    geometryType?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    featureCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    srid?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    boundsMinx?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    boundsMiny?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    boundsMaxx?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPackageLayer
     */
    boundsMaxy?: number;
    /**
     * 
     * @type {any}
     * @memberof GeoPackageLayer
     */
    style?: any;
    /**
     * Layer description
     * @type {string}
     * @memberof GeoPackageLayer
     */
    description?: string;
    /**
     * Whether the layer is visible by default
     * @type {boolean}
     * @memberof GeoPackageLayer
     */
    visible?: boolean;
    /**
     * Minimum zoom level for layer visibility
     * @type {number}
     * @memberof GeoPackageLayer
     */
    minZoom?: number;
    /**
     * Maximum zoom level for layer visibility
     * @type {number}
     * @memberof GeoPackageLayer
     */
    maxZoom?: number;
    /**
     * Layer attribute schema information (only present when include_attributes=true)
     * @type {Array<LayerAttribute>}
     * @memberof GeoPackageLayer
     */
    attributes?: Array<LayerAttribute>;
    /**
     * 
     * @type {GeoPackageLayerSampleFeatures}
     * @memberof GeoPackageLayer
     */
    sampleFeatures?: GeoPackageLayerSampleFeatures;
}
/**
 * Sample features from this layer (only present when include_sample_features=true)
 * @export
 * @interface GeoPackageLayerSampleFeatures
 */
export interface GeoPackageLayerSampleFeatures {
    /**
     * 
     * @type {string}
     * @memberof GeoPackageLayerSampleFeatures
     */
    type?: GeoPackageLayerSampleFeatures.TypeEnum;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof GeoPackageLayerSampleFeatures
     */
    features?: Array<GeoJSONFeature>;
}

/**
 * @export
 * @namespace GeoPackageLayerSampleFeatures
 */
export namespace GeoPackageLayerSampleFeatures {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FeatureCollection = <any> 'FeatureCollection'
    }
}
/**
 * für die Erstellung und Darstellung von Polygonen
 * @export
 * @interface GeoPolygon
 */
export interface GeoPolygon {
    /**
     * 
     * @type {string}
     * @memberof GeoPolygon
     */
    type: GeoPolygon.TypeEnum;
    /**
     * 
     * @type {GeoPolygonGeo}
     * @memberof GeoPolygon
     */
    geo: GeoPolygonGeo;
    /**
     * Format: HH:MM:SS
     * @type {Date}
     * @memberof GeoPolygon
     */
    begin?: Date;
    /**
     * Format: HH:MM:SS
     * @type {Date}
     * @memberof GeoPolygon
     */
    end?: Date;
    /**
     * 
     * @type {string}
     * @memberof GeoPolygon
     */
    rep?: GeoPolygon.RepEnum;
    /**
     * 
     * @type {number}
     * @memberof GeoPolygon
     */
    polyGroup?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoPolygon
     */
    name?: string;
}

/**
 * @export
 * @namespace GeoPolygon
 */
export namespace GeoPolygon {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Traffic = <any> 'traffic',
        Forecast = <any> 'forecast'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RepEnum {
        Daily = <any> 'daily',
        Weekly = <any> 'weekly',
        Yearly = <any> 'yearly'
    }
}
/**
 * 
 * @export
 * @interface GeoPolygonGeo
 */
export interface GeoPolygonGeo {
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof GeoPolygonGeo
     */
    coordinates?: Array<Array<number>>;
    /**
     * 
     * @type {string}
     * @memberof GeoPolygonGeo
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface GeoPolygonWithId
 */
export interface GeoPolygonWithId extends GeoPolygon {
    /**
     * 
     * @type {number}
     * @memberof GeoPolygonWithId
     */
    id?: number;
}

/**
 * @export
 * @namespace GeoPolygonWithId
 */
export namespace GeoPolygonWithId {
}
/**
 * 
 * @export
 * @interface GeocodingbulkData
 */
export interface GeocodingbulkData {
    /**
     * 
     * @type {Point}
     * @memberof GeocodingbulkData
     */
    geometry?: Point;
}
/**
 * GeoJSon geometry
 * @export
 * @interface Geometry
 */
export interface Geometry {
    /**
     * the geometry type
     * @type {string}
     * @memberof Geometry
     */
    type: Geometry.TypeEnum;
}

/**
 * @export
 * @namespace Geometry
 */
export namespace Geometry {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Point = <any> 'Point',
        LineString = <any> 'LineString',
        Polygon = <any> 'Polygon',
        MultiPolygon = <any> 'MultiPolygon'
    }
}
/**
 * 
 * @export
 * @interface GeopackageBody
 */
export interface GeopackageBody {
    /**
     * 
     * @type {Blob}
     * @memberof GeopackageBody
     */
    file?: Blob;
}
/**
 * 
 * @export
 * @interface ImportError
 */
export interface ImportError {
    /**
     * 
     * @type {Adress}
     * @memberof ImportError
     */
    originAdress?: Adress;
    /**
     * 
     * @type {string}
     * @memberof ImportError
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface ImportResponse
 */
export interface ImportResponse {
    /**
     * 
     * @type {string}
     * @memberof ImportResponse
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportResponse
     */
    code?: number;
    /**
     * 
     * @type {Array<ModelImport>}
     * @memberof ImportResponse
     */
    data?: Array<ModelImport>;
}
/**
 * 
 * @export
 * @interface ImportSettings
 */
export interface ImportSettings {
    /**
     * 
     * @type {string}
     * @memberof ImportSettings
     */
    officeName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportSettings
     */
    transports?: Array<ImportSettings.TransportsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof ImportSettings
     */
    geocoding?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportSettings
     */
    typeOfAnalysis?: ImportSettings.TypeOfAnalysisEnum;
    /**
     * 
     * @type {number}
     * @memberof ImportSettings
     */
    officeId?: number;
    /**
     *
     * @type {string}
     * @memberof ImportSettings
     */
    importSessionId?: string;
}

/**
 * @export
 * @namespace ImportSettings
 */
export namespace ImportSettings {
    /**
     * @export
     * @enum {string}
     */
    export enum TransportsEnum {
        BikeAndRide = <any> 'bike_and_ride',
        ParkAndRide = <any> 'park_and_ride',
        ModalOnlyCars = <any> 'modal_only_cars',
        CarsharingFlinkster = <any> 'carsharing_flinkster',
        RideAndCarshareFlinkster = <any> 'ride_and_carshare_flinkster',
        ParkRideAndTaxi = <any> 'park_ride_and_taxi',
        ParkRideAndBike = <any> 'park_ride_and_bike',
        Car = <any> 'car',
        CarElectric = <any> 'car_electric',
        Bike = <any> 'bike',
        EBike = <any> 'eBike',
        EBikesharing = <any> 'eBikesharing',
        Walk = <any> 'walk',
        Train = <any> 'train',
        TrainRegio = <any> 'train_regio',
        Bikescooter = <any> 'bikescooter',
        Taxi = <any> 'taxi',
        RideAndTaxi = <any> 'ride_and_taxi',
        EScooter = <any> 'eScooter',
        EscooterAndRideFirstLastEscooter = <any> 'escooter_and_ride_first_last_escooter',
        Carsharing = <any> 'carsharing',
        ECarsharing = <any> 'eCarsharing',
        Ferry = <any> 'ferry',
        Werksbus = <any> 'werksbus',
        BikeAndWerksbus = <any> 'bike_and_werksbus',
        BahnreaktivierungAndRide = <any> 'bahnreaktivierung_and_ride'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeOfAnalysisEnum {
        JobMOBILEETY = <any> 'JobMOBILEETY',
        BizMOBILEETY = <any> 'BizMOBILEETY'
    }
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse200
     */
    success?: boolean;
    /**
     * 
     * @type {Array<Project>}
     * @memberof InlineResponse200
     */
    projects?: Array<Project>;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 extends Project {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2001
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20010
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20010
     */
    code?: number;
    /**
     * 
     * @type {Array<GeoPackageFile>}
     * @memberof InlineResponse20010
     */
    data?: Array<GeoPackageFile>;
    /**
     * 
     * @type {InlineResponse20010Pagination}
     * @memberof InlineResponse20010
     */
    pagination?: InlineResponse20010Pagination;
}
/**
 * 
 * @export
 * @interface InlineResponse20010Pagination
 */
export interface InlineResponse20010Pagination {
    /**
     * Total number of records
     * @type {number}
     * @memberof InlineResponse20010Pagination
     */
    total?: number;
    /**
     * Records per page
     * @type {number}
     * @memberof InlineResponse20010Pagination
     */
    limit?: number;
    /**
     * Records skipped
     * @type {number}
     * @memberof InlineResponse20010Pagination
     */
    offset?: number;
    /**
     * Whether more records exist
     * @type {boolean}
     * @memberof InlineResponse20010Pagination
     */
    hasMore?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011
     */
    code?: number;
    /**
     * 
     * @type {InlineResponse20011Data}
     * @memberof InlineResponse20011
     */
    data?: InlineResponse20011Data;
    /**
     * 
     * @type {InlineResponse20011Validation}
     * @memberof InlineResponse20011
     */
    validation?: InlineResponse20011Validation;
}
/**
 * 
 * @export
 * @interface InlineResponse20011Data
 */
export interface InlineResponse20011Data {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011Data
     */
    geopackageId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InlineResponse20011Data
     */
    layers?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011Data
     */
    mode?: InlineResponse20011Data.ModeEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011Data
     */
    fileName?: string;
}

/**
 * @export
 * @namespace InlineResponse20011Data
 */
export namespace InlineResponse20011Data {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        Insert = <any> 'insert',
        Update = <any> 'update'
    }
}
/**
 * 
 * @export
 * @interface InlineResponse20011Validation
 */
export interface InlineResponse20011Validation {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011Validation
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011Validation
     */
    fileSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20011Validation
     */
    isValid?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20011Validation
     */
    validationMessages?: Array<string>;
    /**
     * 
     * @type {Array<InlineResponse20011ValidationLayers>}
     * @memberof InlineResponse20011Validation
     */
    layers?: Array<InlineResponse20011ValidationLayers>;
}
/**
 * 
 * @export
 * @interface InlineResponse20011ValidationLayers
 */
export interface InlineResponse20011ValidationLayers {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011ValidationLayers
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011ValidationLayers
     */
    featureCount?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011ValidationLayers
     */
    geometryType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20011ValidationLayers
     */
    attributes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20011ValidationLayers
     */
    isValid?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse20011ValidationLayers
     */
    validationMessages?: Array<string>;
}
/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20012
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20012
     */
    code?: number;
    /**
     * 
     * @type {Array<GeoPackageLayer>}
     * @memberof InlineResponse20012
     */
    data?: Array<GeoPackageLayer>;
    /**
     * 
     * @type {InlineResponse20012Metadata}
     * @memberof InlineResponse20012
     */
    metadata?: InlineResponse20012Metadata;
}
/**
 * 
 * @export
 * @interface InlineResponse20012Metadata
 */
export interface InlineResponse20012Metadata {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20012Metadata
     */
    geopackageName?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20012Metadata
     */
    layerCount?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 extends GeoJSONFeatureCollection {
    /**
     * 
     * @type {GeoJSONFeatureCollectionMetadata}
     * @memberof InlineResponse20013
     */
    metadata?: GeoJSONFeatureCollectionMetadata;
}

/**
 * @export
 * @namespace InlineResponse20013
 */
export namespace InlineResponse20013 {
}
/**
 * 
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20014
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20015
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20015
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20015
     */
    deletedCount?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InlineResponse20015
     */
    failedIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
    /**
     * List of address IDs that are used by other offices
     * @type {Array<number>}
     * @memberof InlineResponse20016
     */
    usedAddressIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20017
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20018
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20019
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20019
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20019
     */
    officeId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20019
     */
    transportType?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 extends Company {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2002
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    legCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    pathId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    routeTransport?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 extends Company {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2003
     */
    successful?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 extends Shift {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2004
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 extends MetricData {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2005
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
    /**
     * id returned by user-management tool
     * @type {string}
     * @memberof InlineResponse2007
     */
    userId?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2008
     */
    message?: string;
    /**
     * 
     * @type {Array<Path>}
     * @memberof InlineResponse2008
     */
    insertedPaths?: Array<Path>;
    /**
     * List of address IDs that were skipped because paths already exist
     * @type {Array<number>}
     * @memberof InlineResponse2008
     */
    skippedAddressIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2009
     */
    success?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2009
     */
    adressId?: number;
    /**
     * 
     * @type {GeocodingbulkData}
     * @memberof InlineResponse2009
     */
    data?: GeocodingbulkData;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2009
     */
    error?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse201
 */
export interface InlineResponse201 extends GeoPolygonWithId {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse201
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse2011
 */
export interface InlineResponse2011 extends Offices {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2011
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse2012
 */
export interface InlineResponse2012 extends Shift {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2012
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse2013
 */
export interface InlineResponse2013 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2013
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2013
     */
    message?: string;
    /**
     * 
     * @type {Array<OfficeParametersWithId>}
     * @memberof InlineResponse2013
     */
    parameters?: Array<OfficeParametersWithId>;
}
/**
 * 
 * @export
 * @interface InlineResponse2XX
 */
export interface InlineResponse2XX {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2XX
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2XX
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface LayerAttribute
 */
export interface LayerAttribute {
    /**
     * Attribute name
     * @type {string}
     * @memberof LayerAttribute
     */
    name?: string;
    /**
     * Data type of the attribute (e.g., int64, float64, object)
     * @type {string}
     * @memberof LayerAttribute
     */
    type?: string;
    /**
     * Whether the attribute allows null values
     * @type {boolean}
     * @memberof LayerAttribute
     */
    nullable?: boolean;
}
/**
 * 
 * @export
 * @interface LayerValidation
 */
export interface LayerValidation {
    /**
     * 
     * @type {string}
     * @memberof LayerValidation
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof LayerValidation
     */
    featureCount?: number;
    /**
     * 
     * @type {string}
     * @memberof LayerValidation
     */
    geometryType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LayerValidation
     */
    attributes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LayerValidation
     */
    isValid?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LayerValidation
     */
    validationMessages?: Array<string>;
}
/**
 * Routenabschnitt
 * @export
 * @interface Leg
 */
export interface Leg {
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    pathId?: number;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    routeId?: number;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    rpId?: number;
    /**
     * 
     * @type {string}
     * @memberof Leg
     */
    transport?: string;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    co2?: number;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    distance?: number;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    cost?: number;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    drivingTimeInMins?: number;
    /**
     * 
     * @type {number}
     * @memberof Leg
     */
    sport?: number;
    /**
     * 
     * @type {string}
     * @memberof Leg
     */
    depature?: string;
    /**
     * 
     * @type {string}
     * @memberof Leg
     */
    arrival?: string;
}
/**
 * GeoJSon geometry
 * @export
 * @interface LineString
 */
export interface LineString extends Geometry {
    /**
     * 
     * @type {Array<Point2D>}
     * @memberof LineString
     */
    coordinates?: Array<Point2D>;
}

/**
 * @export
 * @namespace LineString
 */
export namespace LineString {
}
/**
 * consists of the originId of belonging path and the value of the metric
 * @export
 * @interface MetricData
 */
export interface MetricData {
    /**
     * 
     * @type {number}
     * @memberof MetricData
     */
    originId?: number;
}
/**
 * Metriken welche abgegeben werden
 * @export
 * @interface Metrics
 */
export interface Metrics {
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    co2: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    cost: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    sport: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    timeInMins: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    distance: number;
}
/**
 * 
 * @export
 * @interface MobScore
 */
export interface MobScore {
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    weightCo2?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    weightSport?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    weightTime?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    weightCost?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    budgetCo2?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    budgetSport?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    budgetTime?: number;
    /**
     * 
     * @type {number}
     * @memberof MobScore
     */
    budgetCost?: number;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * HTTP status code
     * @type {number}
     * @memberof ModelError
     */
    code: number;
    /**
     * error message
     * @type {string}
     * @memberof ModelError
     */
    message: string;
    /**
     * Always false for errors
     * @type {boolean}
     * @memberof ModelError
     */
    success: boolean;
}
/**
 * 
 * @export
 * @interface ModelImport
 */
export interface ModelImport {
    /**
     * 
     * @type {ImportSettings}
     * @memberof ModelImport
     */
    settings?: ImportSettings;
    /**
     * 
     * @type {Array<ImportError>}
     * @memberof ModelImport
     */
    errors?: Array<ImportError>;
    /**
     * Is a number between 0 and 1 and serves as an indicator of progress of the import.
     * @type {number}
     * @memberof ModelImport
     */
    status?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelImport
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface OfficeApiView
 */
export interface OfficeApiView {
    /**
     * 
     * @type {number}
     * @memberof OfficeApiView
     */
    officeId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    officeName?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    houseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    district?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    postalCode?: string;
    /**
     * 
     * @type {Point}
     * @memberof OfficeApiView
     */
    geo?: Point;
    /**
     * 
     * @type {number}
     * @memberof OfficeApiView
     */
    adressId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    officeType?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeApiView
     */
    companyName?: string;
    /**
     * 
     * @type {number}
     * @memberof OfficeApiView
     */
    projectId?: number;
    /**
     * 
     * @type {number}
     * @memberof OfficeApiView
     */
    companyId?: number;
}
/**
 * 
 * @export
 * @interface OfficeParametersWithId
 */
export interface OfficeParametersWithId extends OfficeParametersWithoutId {
    /**
     * Primary key
     * @type {number}
     * @memberof OfficeParametersWithId
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface OfficeParametersWithoutId
 */
export interface OfficeParametersWithoutId {
    /**
     * Foreign key to office table
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    officeId?: number;
    /**
     * Type of transport (car, bike, train, etc.)
     * @type {string}
     * @memberof OfficeParametersWithoutId
     */
    transportType?: string;
    /**
     * Average speed in km/h
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    speed?: number;
    /**
     * Additional time for starting journey (minutes)
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    addedTimeStart?: number;
    /**
     * Additional time for parking (minutes)
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    addedTimeParking?: number;
    /**
     * Fixed additional time (minutes)
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    addedTimeFixed?: number;
    /**
     * Relative time factor
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    addedTimeRelative?: number;
    /**
     * Sum of additional times (auto-calculated)
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    addedTimeSum?: number;
    /**
     * CO2 emissions per kilometer
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    co2PerKm?: number;
    /**
     * Fixed CO2 emissions
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    co2Fixed?: number;
    /**
     * Fixed yearly costs
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    costFixedYear?: number;
    /**
     * Fixed monthly costs
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    costFixedMonth?: number;
    /**
     * Fixed daily costs
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    costFixedDay?: number;
    /**
     * Variable cost per kilometer
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    costPerKm?: number;
    /**
     * Exercise/sport value per kilometer
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    sportPerKm?: number;
    /**
     * Minimum practical range in kilometers
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    rangeMinKm?: number;
    /**
     * Maximum practical range in kilometers
     * @type {number}
     * @memberof OfficeParametersWithoutId
     */
    rangeMaxKm?: number;
    /**
     * Timestamp of creation
     * @type {Date}
     * @memberof OfficeParametersWithoutId
     */
    createdAt?: Date;
    /**
     * Timestamp of last update
     * @type {Date}
     * @memberof OfficeParametersWithoutId
     */
    updatedAt?: Date;
}
/**
 * 
 * @export
 * @interface Offices
 */
export interface Offices extends OfficesWithoutId {
    /**
     * 
     * @type {number}
     * @memberof Offices
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface OfficesWithoutId
 */
export interface OfficesWithoutId {
    /**
     * 
     * @type {string}
     * @memberof OfficesWithoutId
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OfficesWithoutId
     */
    adressId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfficesWithoutId
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficesWithoutId
     */
    owner?: string;
}
/**
 * 
 * @export
 * @interface OneWayRoute
 */
export interface OneWayRoute {
    /**
     * 
     * @type {number}
     * @memberof OneWayRoute
     */
    transport?: number;
    /**
     * 
     * @type {Array<RouteLeg>}
     * @memberof OneWayRoute
     */
    legs?: Array<RouteLeg>;
}
/**
 * 
 * @export
 * @interface ParametersWithId
 */
export interface ParametersWithId extends ParametersWithoutId {
    /**
     * 
     * @type {number}
     * @memberof ParametersWithId
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface ParametersWithoutId
 */
export interface ParametersWithoutId {
    /**
     * 
     * @type {string}
     * @memberof ParametersWithoutId
     */
    transportType?: string;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    speed?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    addedTimeStart?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    addedTimeParkig?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    addedTimeFixed?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    addedTimeRelative?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    addedTimeSum?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    co2PerKm?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    co2Fixed?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    costFixedYear?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    costFixedMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    costFixedDay?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    costPerKm?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    sportPerKm?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    rangeMinKm?: number;
    /**
     * 
     * @type {number}
     * @memberof ParametersWithoutId
     */
    rangeMaxKm?: number;
}
/**
 * Describes a path, that is used (typically) by a worker for commuting. We use paths to make cleverroute requests.
 * @export
 * @interface Path
 */
export interface Path {
    /**
     * 
     * @type {Adress}
     * @memberof Path
     */
    orgin?: Adress;
    /**
     * 
     * @type {Adress}
     * @memberof Path
     */
    destination?: Adress;
    /**
     * 
     * @type {string}
     * @memberof Path
     */
    arrival?: string;
    /**
     * 
     * @type {string}
     * @memberof Path
     */
    departure?: string;
}
/**
 * origin and destination are identifiers of adresses in the database
 * @export
 * @interface PathBody
 */
export interface PathBody {
    /**
     * 
     * @type {number}
     * @memberof PathBody
     */
    originId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathBody
     */
    destinationId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathBody
     */
    shiftId?: number;
}
/**
 * origin and destination are identifiers of adresses in the database
 * @export
 * @interface PathBodyPUT
 */
export interface PathBodyPUT {
    /**
     * 
     * @type {number}
     * @memberof PathBodyPUT
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof PathBodyPUT
     */
    originId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathBodyPUT
     */
    destinationId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathBodyPUT
     */
    shiftId?: number;
}
/**
 * 
 * @export
 * @interface PathWithId
 */
export interface PathWithId extends Path {
    /**
     * 
     * @type {number}
     * @memberof PathWithId
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface PathsBody
 */
export interface PathsBody extends PathWithId {
    /**
     * 
     * @type {boolean}
     * @memberof PathsBody
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface PathsBody1
 */
export interface PathsBody1 extends Path {
    /**
     * 
     * @type {boolean}
     * @memberof PathsBody1
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface PathsBulkInsertBody
 */
export interface PathsBulkInsertBody {
    /**
     * List of origin address IDs
     * @type {Array<number>}
     * @memberof PathsBulkInsertBody
     */
    originIds: Array<number>;
    /**
     * ID of the destination (office)
     * @type {number}
     * @memberof PathsBulkInsertBody
     */
    destinationId: number;
    /**
     * ID of the shift
     * @type {number}
     * @memberof PathsBulkInsertBody
     */
    shiftId: number;
}
/**
 * 
 * @export
 * @interface PathsOfficeBody
 */
export interface PathsOfficeBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof PathsOfficeBody
     */
    pathIds: Array<number>;
}
/**
 * 
 * @export
 * @interface PathsResponse
 */
export interface PathsResponse {
    /**
     * 
     * @type {string}
     * @memberof PathsResponse
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof PathsResponse
     */
    code?: number;
    /**
     * 
     * @type {Array<PathWithId>}
     * @memberof PathsResponse
     */
    data?: Array<PathWithId>;
}
/**
 * 
 * @export
 * @interface PathsView
 */
export interface PathsView {
    /**
     * 
     * @type {number}
     * @memberof PathsView
     */
    projectId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsView
     */
    pathId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsView
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsView
     */
    originId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsView
     */
    destinationId?: number;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    departure?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    arrival?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    originStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    originHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    originPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    originDistrict?: string;
    /**
     * 
     * @type {Point}
     * @memberof PathsView
     */
    originGeo?: Point;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    destinationStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    destinationHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    destinationPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsView
     */
    destinationDistrict?: string;
    /**
     * 
     * @type {Point}
     * @memberof PathsView
     */
    destinationGeo?: Point;
}
/**
 * 
 * @export
 * @interface PathsViewWithoutGeo
 */
export interface PathsViewWithoutGeo {
    /**
     * 
     * @type {number}
     * @memberof PathsViewWithoutGeo
     */
    projectId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsViewWithoutGeo
     */
    pathId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsViewWithoutGeo
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsViewWithoutGeo
     */
    originId?: number;
    /**
     * 
     * @type {number}
     * @memberof PathsViewWithoutGeo
     */
    destinationId?: number;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    departure?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    arrival?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    originStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    originHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    originPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    originDistrict?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    originGeo?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    destinationStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    destinationHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    destinationPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PathsViewWithoutGeo
     */
    destinationDistrict?: string;
    /**
     * 
     * @type {Point}
     * @memberof PathsViewWithoutGeo
     */
    destinationGeo?: Point;
}
/**
 * GeoJSon geometry
 * @export
 * @interface Point
 */
export interface Point extends Geometry {
    /**
     * 
     * @type {Point2D}
     * @memberof Point
     */
    coordinates?: Point2D;
}

/**
 * @export
 * @namespace Point
 */
export namespace Point {
}
/**
 * 
 * @export
 */
export type Point2D = Array<number>
/**
 * 
 * @export
 * @interface Poll
 */
export interface Poll {
    /**
     * 
     * @type {number}
     * @memberof Poll
     */
    monthsInOrg?: number;
    /**
     * 
     * @type {number}
     * @memberof Poll
     */
    monthsInOrgMax?: number;
    /**
     * 
     * @type {number}
     * @memberof Poll
     */
    workdaysPerWeek?: number;
    /**
     * 
     * @type {number}
     * @memberof Poll
     */
    workdaysPerWeekMax?: number;
    /**
     * 
     * @type {number}
     * @memberof Poll
     */
    homeofficeDaysPerWeekMax?: number;
    /**
     * 
     * @type {number}
     * @memberof Poll
     */
    homeofficeDaysPerWeek?: number;
    /**
     * 
     * @type {Array<RouteTotal>}
     * @memberof Poll
     */
    routes?: Array<RouteTotal>;
}
/**
 * GeoJSon geometry
 * @export
 * @interface Polygon
 */
export interface Polygon extends Geometry {
    /**
     * 
     * @type {Array<Array<Point2D>>}
     * @memberof Polygon
     */
    coordinates?: Array<Array<Point2D>>;
}

/**
 * @export
 * @namespace Polygon
 */
export namespace Polygon {
}
/**
 * available projects
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    name: string;
}
/**
 * 
 * @export
 */
export type Route = Array<Leg>
/**
 * 
 * @export
 * @interface RouteErrorWithId
 */
export interface RouteErrorWithId extends RouteErrorWithoutId {
    /**
     * 
     * @type {number}
     * @memberof RouteErrorWithId
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface RouteErrorWithoutId
 */
export interface RouteErrorWithoutId {
    /**
     * 
     * @type {string}
     * @memberof RouteErrorWithoutId
     */
    transport?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteErrorWithoutId
     */
    pathId?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteErrorWithoutId
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteErrorWithoutId
     */
    warning?: string;
}
/**
 * 
 * @export
 * @interface RouteLeg
 */
export interface RouteLeg {
    /**
     * transport-ID
     * @type {number}
     * @memberof RouteLeg
     */
    transport?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteLeg
     */
    arrival?: string;
    /**
     * 
     * @type {Date}
     * @memberof RouteLeg
     */
    departure?: Date;
    /**
     * e.g. \"car\", \"train\"
     * @type {string}
     * @memberof RouteLeg
     */
    mode?: string;
    /**
     * description as path info like 'Stuttgart HBF -> Frankfurt HBF'
     * @type {string}
     * @memberof RouteLeg
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteLeg
     */
    details?: string;
    /**
     * geojson of the leg
     * @type {string}
     * @memberof RouteLeg
     */
    geometry?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteLeg
     */
    distanceKm?: number;
    /**
     * cost of leg in cent
     * @type {number}
     * @memberof RouteLeg
     */
    costCents?: number;
    /**
     * part-number to which this leg belongs i.e. part-number 0, 1 ...
     * @type {number}
     * @memberof RouteLeg
     */
    costPart?: number;
    /**
     * like 'vbn'
     * @type {string}
     * @memberof RouteLeg
     */
    verbundNameShort?: string;
    /**
     * direction of the leg e.g. if the train drives in the direction of Berlin HBF, then it shows that
     * @type {string}
     * @memberof RouteLeg
     */
    direction?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteLeg
     */
    arrivalPlatform?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteLeg
     */
    departurePlatform?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteLeg
     */
    co2?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteLeg
     */
    transportType?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteLeg
     */
    transportName?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteLeg
     */
    durationM?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RouteLeg
     */
    sharingStationalCost?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RouteLeg
     */
    sharingActivationCost?: boolean;
}
/**
 * average metric values of journey there and back
 * @export
 * @interface RouteMetrics
 */
export interface RouteMetrics {
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    sport?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    co2Fixed?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    co2Journey?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    time?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    costFixed?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    costJourney?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    costJourneyThere?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteMetrics
     */
    costJourneyBack?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RouteMetrics
     */
    isCostJourneyThereComplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RouteMetrics
     */
    isCostJourneyBackComplete?: boolean;
}
/**
 * 
 * @export
 * @interface RouteResults
 */
export interface RouteResults {
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    pathId?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    routeId?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteResults
     */
    transportId?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    distanceKm?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    time?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    cost?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    co2?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteResults
     */
    sport?: number;
}
/**
 * contains whole 2-way route average metric values of a single transport type like car bicycle
 * @export
 * @interface RouteTotal
 */
export interface RouteTotal {
    /**
     * 
     * @type {OneWayRoute}
     * @memberof RouteTotal
     */
    toDestination?: OneWayRoute;
    /**
     * 
     * @type {OneWayRoute}
     * @memberof RouteTotal
     */
    fromDestination?: OneWayRoute;
    /**
     * 
     * @type {RouteMetrics}
     * @memberof RouteTotal
     */
    metrics?: RouteMetrics;
    /**
     * 
     * @type {Array<string>}
     * @memberof RouteTotal
     */
    routeWarnings?: Array<string>;
}
/**
 * 
 * @export
 * @interface Shift
 */
export interface Shift extends ShiftWithoutId {
    /**
     * 
     * @type {number}
     * @memberof Shift
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Shift
     */
    officeId?: number;
    /**
     * 
     * @type {string}
     * @memberof Shift
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Shift
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof Shift
     */
    end?: string;
}
/**
 * 
 * @export
 * @interface ShiftWithoutId
 */
export interface ShiftWithoutId {
    /**
     * 
     * @type {string}
     * @memberof ShiftWithoutId
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShiftWithoutId
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ShiftWithoutId
     */
    end?: string;
    /**
     * 
     * @type {number}
     * @memberof ShiftWithoutId
     */
    officeId?: number;
}
/**
 * represents a station
 * @export
 * @interface Station
 */
export interface Station {
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    stationId?: number;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    type?: string;
    /**
     * 
     * @type {Point}
     * @memberof Station
     */
    geo?: Point;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * Current progress percentage.
     * @type {number}
     * @memberof Status
     */
    progress?: number;
}
/**
 * 
 * @export
 * @interface StatusResponse
 */
export interface StatusResponse {
    /**
     * whether the response is successful (=true) or not
     * @type {boolean}
     * @memberof StatusResponse
     */
    status?: boolean;
    /**
     * warnings or error messages if status is false
     * @type {string}
     * @memberof StatusResponse
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface TransportChain
 */
export interface TransportChain {
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    pathId?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    routeId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    routeTransport?: string;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    legId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    direction?: TransportChain.DirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    departureStation?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    departureTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    arrivalStation?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    arrivalTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportChain
     */
    legTransport?: string;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    distanceKm?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    time?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    co2?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    cost?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportChain
     */
    sport?: number;
    /**
     * 
     * @type {Point}
     * @memberof TransportChain
     */
    departureStationGeo?: Point;
    /**
     * 
     * @type {Point}
     * @memberof TransportChain
     */
    arrivalStationGeo?: Point;
    /**
     * 
     * @type {Geometry}
     * @memberof TransportChain
     */
    legGeo?: Geometry;
}

/**
 * @export
 * @namespace TransportChain
 */
export namespace TransportChain {
    /**
     * @export
     * @enum {string}
     */
    export enum DirectionEnum {
        To = <any> 'to',
        From = <any> 'from'
    }
}
/**
 * 
 * @export
 * @interface UploadRequest
 */
export interface UploadRequest {
    /**
     * The ID of the company
     * @type {number}
     * @memberof UploadRequest
     */
    companyId: number;
    /**
     * The name of the company
     * @type {string}
     * @memberof UploadRequest
     */
    companyName: string;
    /**
     * The CSV data as an array of objects
     * @type {Array<any>}
     * @memberof UploadRequest
     */
    fileData: Array<any>;
}
/**
 * 
 * @export
 * @interface UploadResponse
 */
export interface UploadResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UploadResponse
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    scopes?: Array<string>;
    /**
     * role of the user which reflects its rights
     * @type {string}
     * @memberof User
     */
    userrole?: string;
    /**
     * username which is used for log-in and shoud be unqiue
     * @type {string}
     * @memberof User
     */
    username?: string;
    /**
     * needed for sending notifications are restoring password
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * used to address the user by its name
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * used to address the user by its name
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * user-password (should contain temporary password)
     * @type {string}
     * @memberof User
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface UserCompanyResponse
 */
export interface UserCompanyResponse {
    /**
     * 
     * @type {number}
     * @memberof UserCompanyResponse
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserCompanyResponse
     */
    companyId?: number;
}
/**
 * 
 * @export
 * @interface UserProjectRelation
 */
export interface UserProjectRelation extends User {
    /**
     * ids of the projects used in the DB
     * @type {Array<number>}
     * @memberof UserProjectRelation
     */
    projectIds?: Array<number>;
    /**
     * user-role the user should have in this project
     * @type {string}
     * @memberof UserProjectRelation
     */
    userRole?: UserProjectRelation.UserRoleEnum;
}

/**
 * @export
 * @namespace UserProjectRelation
 */
export namespace UserProjectRelation {
    /**
     * @export
     * @enum {string}
     */
    export enum UserRoleEnum {
        LicenceManager = <any> 'licence-manager',
        SimpleUser = <any> 'simple-user',
        TestUser = <any> 'test-user'
    }
}
/**
 * 
 * @export
 * @interface ZipcodeFeature
 */
export interface ZipcodeFeature {
    /**
     * 
     * @type {string}
     * @memberof ZipcodeFeature
     */
    type?: string;
    /**
     * 
     * @type {ZipcodeFeatureProperties}
     * @memberof ZipcodeFeature
     */
    properties?: ZipcodeFeatureProperties;
    /**
     * 
     * @type {Geometry}
     * @memberof ZipcodeFeature
     */
    geometry?: Geometry;
}
/**
 * 
 * @export
 * @interface ZipcodeFeatureProperties
 */
export interface ZipcodeFeatureProperties {
    /**
     * The zip code
     * @type {string}
     * @memberof ZipcodeFeatureProperties
     */
    plz?: string;
    /**
     * Additional information about the zip code area
     * @type {string}
     * @memberof ZipcodeFeatureProperties
     */
    note?: string;
    /**
     * Number of inhabitants in the zip code area
     * @type {number}
     * @memberof ZipcodeFeatureProperties
     */
    einwohner?: number;
    /**
     * Area of the zip code in square kilometers
     * @type {number}
     * @memberof ZipcodeFeatureProperties
     */
    qkm?: number;
}
/**
 * 
 * @export
 * @interface ZipcodeResponse
 */
export interface ZipcodeResponse {
    /**
     * 
     * @type {string}
     * @memberof ZipcodeResponse
     */
    type?: string;
    /**
     * 
     * @type {Array<ZipcodeFeature>}
     * @memberof ZipcodeResponse
     */
    features?: Array<ZipcodeFeature>;
}
/**
 * 
 * @export
 * @interface ZipcodesBody
 */
export interface ZipcodesBody {
    /**
     * Array of 5-digit German postal codes
     * @type {Array<string>}
     * @memberof ZipcodesBody
     */
    zipCodes: Array<string>;
}
/**
 * AdressesApi - fetch parameter creator
 * @export
 */
export const AdressesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of address IDs that are used by offices other than the specified office
         * @summary Check if addresses are used by offices other than the specified one
         * @param {AdressesCheckusageBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAddressUsage(body?: AdressesCheckusageBody, options: any = {}): FetchArgs {
            const localVarPath = `/adresses/check-usage`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdressesCheckusageBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * use the identifier of an existing Object to delete it
         * @summary delete an existing adress
         * @param {number} adId Identifier used for adresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdress(adId: number, options: any = {}): FetchArgs {
            // verify required parameter 'adId' is not null or undefined
            if (adId === null || adId === undefined) {
                throw new RequiredError('adId','Required parameter adId was null or undefined when calling deleteAdress.');
            }
            const localVarPath = `/adresses`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (adId !== undefined) {
                localVarQueryParameter['adId'] = adId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * provide an array of address IDs to delete multiple addresses in a single operation
         * @summary delete multiple existing addresses at once
         * @param {AdressesBatchBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdressesBatch(body: AdressesBatchBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deleteAdressesBatch.');
            }
            const localVarPath = `/adresses/batch`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdressesBatchBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get an adress with a given id
         * @param {number} adressId Identifier for adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdress(adressId: number, options: any = {}): FetchArgs {
            // verify required parameter 'adressId' is not null or undefined
            if (adressId === null || adressId === undefined) {
                throw new RequiredError('adressId','Required parameter adressId was null or undefined when calling getAdress.');
            }
            const localVarPath = `/adress_with_id`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (adressId !== undefined) {
                localVarQueryParameter['adress_id'] = adressId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get an adress_id with given adress data
         * @param {string} street street of the adress
         * @param {string} postalCode postal code of the adress
         * @param {string} district district of the adress
         * @param {string} [houseNumber] house number of the adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdressId(street: string, postalCode: string, district: string, houseNumber?: string, options: any = {}): FetchArgs {
            // verify required parameter 'street' is not null or undefined
            if (street === null || street === undefined) {
                throw new RequiredError('street','Required parameter street was null or undefined when calling getAdressId.');
            }
            // verify required parameter 'postalCode' is not null or undefined
            if (postalCode === null || postalCode === undefined) {
                throw new RequiredError('postalCode','Required parameter postalCode was null or undefined when calling getAdressId.');
            }
            // verify required parameter 'district' is not null or undefined
            if (district === null || district === undefined) {
                throw new RequiredError('district','Required parameter district was null or undefined when calling getAdressId.');
            }
            const localVarPath = `/adress_with_data`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (street !== undefined) {
                localVarQueryParameter['street'] = street;
            }

            if (houseNumber !== undefined) {
                localVarQueryParameter['house_number'] = houseNumber;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }

            if (district !== undefined) {
                localVarQueryParameter['district'] = district;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all adresses contained in one project
         * @param {number} [projId] Identifier for projects
         * @param {number} [companyId] company identifier
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresses(projId?: number, companyId?: number, officeId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/adresses`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new address entry in the database
         * @summary post an individual address
         * @param {Adress} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdress(body: Adress, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postAdress.');
            }
            const localVarPath = `/adresses`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Adress" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update an existing adress
         * @param {AdressWithId} body updated adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdress(body: AdressWithId, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling putAdress.');
            }
            const localVarPath = `/adresses`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdressWithId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdressesApi - functional programming interface
 * @export
 */
export const AdressesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns a list of address IDs that are used by offices other than the specified office
         * @summary Check if addresses are used by offices other than the specified one
         * @param {AdressesCheckusageBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAddressUsage(body?: AdressesCheckusageBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20016> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).checkAddressUsage(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * use the identifier of an existing Object to delete it
         * @summary delete an existing adress
         * @param {number} adId Identifier used for adresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdress(adId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2XX> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).deleteAdress(adId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * provide an array of address IDs to delete multiple addresses in a single operation
         * @summary delete multiple existing addresses at once
         * @param {AdressesBatchBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdressesBatch(body: AdressesBatchBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20015> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).deleteAdressesBatch(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get an adress with a given id
         * @param {number} adressId Identifier for adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdress(adressId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdressWithId>> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).getAdress(adressId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get an adress_id with given adress data
         * @param {string} street street of the adress
         * @param {string} postalCode postal code of the adress
         * @param {string} district district of the adress
         * @param {string} [houseNumber] house number of the adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdressId(street: string, postalCode: string, district: string, houseNumber?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdressWithId>> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).getAdressId(street, postalCode, district, houseNumber, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get all adresses contained in one project
         * @param {number} [projId] Identifier for projects
         * @param {number} [companyId] company identifier
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresses(projId?: number, companyId?: number, officeId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdressesBody>> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).getAdresses(projId, companyId, officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a new address entry in the database
         * @summary post an individual address
         * @param {Adress} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdress(body: Adress, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdressesBody> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).postAdress(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary update an existing adress
         * @param {AdressWithId} body updated adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdress(body: AdressWithId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdressesBody> {
            const localVarFetchArgs = AdressesApiFetchParamCreator(configuration).putAdress(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdressesApi - factory interface
 * @export
 */
export const AdressesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Returns a list of address IDs that are used by offices other than the specified office
         * @summary Check if addresses are used by offices other than the specified one
         * @param {AdressesCheckusageBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAddressUsage(body?: AdressesCheckusageBody, options?: any) {
            return AdressesApiFp(configuration).checkAddressUsage(body, options)(fetch, basePath);
        },
        /**
         * use the identifier of an existing Object to delete it
         * @summary delete an existing adress
         * @param {number} adId Identifier used for adresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdress(adId: number, options?: any) {
            return AdressesApiFp(configuration).deleteAdress(adId, options)(fetch, basePath);
        },
        /**
         * provide an array of address IDs to delete multiple addresses in a single operation
         * @summary delete multiple existing addresses at once
         * @param {AdressesBatchBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdressesBatch(body: AdressesBatchBody, options?: any) {
            return AdressesApiFp(configuration).deleteAdressesBatch(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get an adress with a given id
         * @param {number} adressId Identifier for adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdress(adressId: number, options?: any) {
            return AdressesApiFp(configuration).getAdress(adressId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get an adress_id with given adress data
         * @param {string} street street of the adress
         * @param {string} postalCode postal code of the adress
         * @param {string} district district of the adress
         * @param {string} [houseNumber] house number of the adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdressId(street: string, postalCode: string, district: string, houseNumber?: string, options?: any) {
            return AdressesApiFp(configuration).getAdressId(street, postalCode, district, houseNumber, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get all adresses contained in one project
         * @param {number} [projId] Identifier for projects
         * @param {number} [companyId] company identifier
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresses(projId?: number, companyId?: number, officeId?: number, options?: any) {
            return AdressesApiFp(configuration).getAdresses(projId, companyId, officeId, options)(fetch, basePath);
        },
        /**
         * Create a new address entry in the database
         * @summary post an individual address
         * @param {Adress} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdress(body: Adress, options?: any) {
            return AdressesApiFp(configuration).postAdress(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary update an existing adress
         * @param {AdressWithId} body updated adress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdress(body: AdressWithId, options?: any) {
            return AdressesApiFp(configuration).putAdress(body, options)(fetch, basePath);
        },
    };
};

/**
 * AdressesApi - object-oriented interface
 * @export
 * @class AdressesApi
 * @extends {BaseAPI}
 */
export class AdressesApi extends BaseAPI {
    /**
     * Returns a list of address IDs that are used by offices other than the specified office
     * @summary Check if addresses are used by offices other than the specified one
     * @param {AdressesCheckusageBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public checkAddressUsage(body?: AdressesCheckusageBody, options?: any) {
        return AdressesApiFp(this.configuration).checkAddressUsage(body, options)(this.fetch, this.basePath);
    }

    /**
     * use the identifier of an existing Object to delete it
     * @summary delete an existing adress
     * @param {number} adId Identifier used for adresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public deleteAdress(adId: number, options?: any) {
        return AdressesApiFp(this.configuration).deleteAdress(adId, options)(this.fetch, this.basePath);
    }

    /**
     * provide an array of address IDs to delete multiple addresses in a single operation
     * @summary delete multiple existing addresses at once
     * @param {AdressesBatchBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public deleteAdressesBatch(body: AdressesBatchBody, options?: any) {
        return AdressesApiFp(this.configuration).deleteAdressesBatch(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get an adress with a given id
     * @param {number} adressId Identifier for adress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public getAdress(adressId: number, options?: any) {
        return AdressesApiFp(this.configuration).getAdress(adressId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get an adress_id with given adress data
     * @param {string} street street of the adress
     * @param {string} postalCode postal code of the adress
     * @param {string} district district of the adress
     * @param {string} [houseNumber] house number of the adress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public getAdressId(street: string, postalCode: string, district: string, houseNumber?: string, options?: any) {
        return AdressesApiFp(this.configuration).getAdressId(street, postalCode, district, houseNumber, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get all adresses contained in one project
     * @param {number} [projId] Identifier for projects
     * @param {number} [companyId] company identifier
     * @param {number} [officeId] Identifier for offices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public getAdresses(projId?: number, companyId?: number, officeId?: number, options?: any) {
        return AdressesApiFp(this.configuration).getAdresses(projId, companyId, officeId, options)(this.fetch, this.basePath);
    }

    /**
     * Create a new address entry in the database
     * @summary post an individual address
     * @param {Adress} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public postAdress(body: Adress, options?: any) {
        return AdressesApiFp(this.configuration).postAdress(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary update an existing adress
     * @param {AdressWithId} body updated adress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdressesApi
     */
    public putAdress(body: AdressWithId, options?: any) {
        return AdressesApiFp(this.configuration).putAdress(body, options)(this.fetch, this.basePath);
    }

}
/**
 * CRExportApi - fetch parameter creator
 * @export
 */
export const CRExportApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the export data for a CR-Import
         * @summary Get the export data for a CR-Import
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crExportGet(originIdFirst: number, originIdLast: number, officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'originIdFirst' is not null or undefined
            if (originIdFirst === null || originIdFirst === undefined) {
                throw new RequiredError('originIdFirst','Required parameter originIdFirst was null or undefined when calling crExportGet.');
            }
            // verify required parameter 'originIdLast' is not null or undefined
            if (originIdLast === null || originIdLast === undefined) {
                throw new RequiredError('originIdLast','Required parameter originIdLast was null or undefined when calling crExportGet.');
            }
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling crExportGet.');
            }
            const localVarPath = `/cr-export`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (originIdFirst !== undefined) {
                localVarQueryParameter['originIdFirst'] = originIdFirst;
            }

            if (originIdLast !== undefined) {
                localVarQueryParameter['originIdLast'] = originIdLast;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the most effective transport for a given origin
         * @summary Get the most effective mode of transport for specific metrics
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostEffectiveTransport(originIdFirst: number, originIdLast: number, officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'originIdFirst' is not null or undefined
            if (originIdFirst === null || originIdFirst === undefined) {
                throw new RequiredError('originIdFirst','Required parameter originIdFirst was null or undefined when calling getMostEffectiveTransport.');
            }
            // verify required parameter 'originIdLast' is not null or undefined
            if (originIdLast === null || originIdLast === undefined) {
                throw new RequiredError('originIdLast','Required parameter originIdLast was null or undefined when calling getMostEffectiveTransport.');
            }
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getMostEffectiveTransport.');
            }
            const localVarPath = `/cr_export_most_effective`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (originIdFirst !== undefined) {
                localVarQueryParameter['originIdFirst'] = originIdFirst;
            }

            if (originIdLast !== undefined) {
                localVarQueryParameter['originIdLast'] = originIdLast;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CRExportApi - functional programming interface
 * @export
 */
export const CRExportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get the export data for a CR-Import
         * @summary Get the export data for a CR-Import
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crExportGet(originIdFirst: number, originIdLast: number, officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CRExportView>> {
            const localVarFetchArgs = CRExportApiFetchParamCreator(configuration).crExportGet(originIdFirst, originIdLast, officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get the most effective transport for a given origin
         * @summary Get the most effective mode of transport for specific metrics
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostEffectiveTransport(originIdFirst: number, originIdLast: number, officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CRExportView>> {
            const localVarFetchArgs = CRExportApiFetchParamCreator(configuration).getMostEffectiveTransport(originIdFirst, originIdLast, officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CRExportApi - factory interface
 * @export
 */
export const CRExportApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get the export data for a CR-Import
         * @summary Get the export data for a CR-Import
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crExportGet(originIdFirst: number, originIdLast: number, officeId: number, options?: any) {
            return CRExportApiFp(configuration).crExportGet(originIdFirst, originIdLast, officeId, options)(fetch, basePath);
        },
        /**
         * Get the most effective transport for a given origin
         * @summary Get the most effective mode of transport for specific metrics
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostEffectiveTransport(originIdFirst: number, originIdLast: number, officeId: number, options?: any) {
            return CRExportApiFp(configuration).getMostEffectiveTransport(originIdFirst, originIdLast, officeId, options)(fetch, basePath);
        },
    };
};

/**
 * CRExportApi - object-oriented interface
 * @export
 * @class CRExportApi
 * @extends {BaseAPI}
 */
export class CRExportApi extends BaseAPI {
    /**
     * Get the export data for a CR-Import
     * @summary Get the export data for a CR-Import
     * @param {number} originIdFirst 
     * @param {number} originIdLast 
     * @param {number} officeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRExportApi
     */
    public crExportGet(originIdFirst: number, originIdLast: number, officeId: number, options?: any) {
        return CRExportApiFp(this.configuration).crExportGet(originIdFirst, originIdLast, officeId, options)(this.fetch, this.basePath);
    }

    /**
     * Get the most effective transport for a given origin
     * @summary Get the most effective mode of transport for specific metrics
     * @param {number} originIdFirst 
     * @param {number} originIdLast 
     * @param {number} officeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRExportApi
     */
    public getMostEffectiveTransport(originIdFirst: number, originIdLast: number, officeId: number, options?: any) {
        return CRExportApiFp(this.configuration).getMostEffectiveTransport(originIdFirst, originIdLast, officeId, options)(this.fetch, this.basePath);
    }

}
/**
 * CRImportApi - fetch parameter creator
 * @export
 */
export const CRImportApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Abort a running import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crImportDelete(options: any = {}): FetchArgs {
            const localVarPath = `/cr-import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start the cleverroute import pipeline
         * @param {ImportSettings} body 
         * @param {number} projectId 
         * @param {number} companyId 
         * @param {number} officeId 
         * @param {number} [rangeStart] 
         * @param {number} [rangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crImportPost(body: ImportSettings, projectId: number, companyId: number, officeId: number, rangeStart?: number, rangeEnd?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling crImportPost.');
            }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new RequiredError('projectId','Required parameter projectId was null or undefined when calling crImportPost.');
            }
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling crImportPost.');
            }
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling crImportPost.');
            }
            const localVarPath = `/cr-import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['office_id'] = officeId;
            }

            if (rangeStart !== undefined) {
                localVarQueryParameter['rangeStart'] = rangeStart;
            }

            if (rangeEnd !== undefined) {
                localVarQueryParameter['rangeEnd'] = rangeEnd;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ImportSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the paths in the database. You can filter for projects
         * @summary get the paths in the database for a project
         * @param {number} projId Identifier for projects
         * @param {number} compId company identifier
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaths(projId: number, compId: number, officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'projId' is not null or undefined
            if (projId === null || projId === undefined) {
                throw new RequiredError('projId','Required parameter projId was null or undefined when calling getPaths.');
            }
            // verify required parameter 'compId' is not null or undefined
            if (compId === null || compId === undefined) {
                throw new RequiredError('compId','Required parameter compId was null or undefined when calling getPaths.');
            }
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getPaths.');
            }
            const localVarPath = `/cr-import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            if (compId !== undefined) {
                localVarQueryParameter['compId'] = compId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CRImportApi - functional programming interface
 * @export
 */
export const CRImportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Abort a running import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crImportDelete(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportResponse> {
            const localVarFetchArgs = CRImportApiFetchParamCreator(configuration).crImportDelete(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Start the cleverroute import pipeline
         * @param {ImportSettings} body 
         * @param {number} projectId 
         * @param {number} companyId 
         * @param {number} officeId 
         * @param {number} [rangeStart] 
         * @param {number} [rangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crImportPost(body: ImportSettings, projectId: number, companyId: number, officeId: number, rangeStart?: number, rangeEnd?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportResponse> {
            const localVarFetchArgs = CRImportApiFetchParamCreator(configuration).crImportPost(body, projectId, companyId, officeId, rangeStart, rangeEnd, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get the paths in the database. You can filter for projects
         * @summary get the paths in the database for a project
         * @param {number} projId Identifier for projects
         * @param {number} compId company identifier
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaths(projId: number, compId: number, officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PathsView>> {
            const localVarFetchArgs = CRImportApiFetchParamCreator(configuration).getPaths(projId, compId, officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CRImportApi - factory interface
 * @export
 */
export const CRImportApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Abort a running import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crImportDelete(options?: any) {
            return CRImportApiFp(configuration).crImportDelete(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Start the cleverroute import pipeline
         * @param {ImportSettings} body 
         * @param {number} projectId 
         * @param {number} companyId 
         * @param {number} officeId 
         * @param {number} [rangeStart] 
         * @param {number} [rangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crImportPost(body: ImportSettings, projectId: number, companyId: number, officeId: number, rangeStart?: number, rangeEnd?: number, options?: any) {
            return CRImportApiFp(configuration).crImportPost(body, projectId, companyId, officeId, rangeStart, rangeEnd, options)(fetch, basePath);
        },
        /**
         * get the paths in the database. You can filter for projects
         * @summary get the paths in the database for a project
         * @param {number} projId Identifier for projects
         * @param {number} compId company identifier
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaths(projId: number, compId: number, officeId: number, options?: any) {
            return CRImportApiFp(configuration).getPaths(projId, compId, officeId, options)(fetch, basePath);
        },
    };
};

/**
 * CRImportApi - object-oriented interface
 * @export
 * @class CRImportApi
 * @extends {BaseAPI}
 */
export class CRImportApi extends BaseAPI {
    /**
     * 
     * @summary Abort a running import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRImportApi
     */
    public crImportDelete(options?: any) {
        return CRImportApiFp(this.configuration).crImportDelete(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Start the cleverroute import pipeline
     * @param {ImportSettings} body 
     * @param {number} projectId 
     * @param {number} companyId 
     * @param {number} officeId 
     * @param {number} [rangeStart] 
     * @param {number} [rangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRImportApi
     */
    public crImportPost(body: ImportSettings, projectId: number, companyId: number, officeId: number, rangeStart?: number, rangeEnd?: number, options?: any) {
        return CRImportApiFp(this.configuration).crImportPost(body, projectId, companyId, officeId, rangeStart, rangeEnd, options)(this.fetch, this.basePath);
    }

    /**
     * get the paths in the database. You can filter for projects
     * @summary get the paths in the database for a project
     * @param {number} projId Identifier for projects
     * @param {number} compId company identifier
     * @param {number} officeId Identifier for offices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRImportApi
     */
    public getPaths(projId: number, compId: number, officeId: number, options?: any) {
        return CRImportApiFp(this.configuration).getPaths(projId, compId, officeId, options)(this.fetch, this.basePath);
    }

}
/**
 * CSVApi - fetch parameter creator
 * @export
 */
export const CSVApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Process and post CSV data for addresses and related information (office, shift, paths, mobscores)
         * @summary Upload CSV file
         * @param {UploadRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCsv(body: UploadRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling uploadCsv.');
            }
            const localVarPath = `/upload`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UploadRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CSVApi - functional programming interface
 * @export
 */
export const CSVApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Process and post CSV data for addresses and related information (office, shift, paths, mobscores)
         * @summary Upload CSV file
         * @param {UploadRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCsv(body: UploadRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadResponse> {
            const localVarFetchArgs = CSVApiFetchParamCreator(configuration).uploadCsv(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CSVApi - factory interface
 * @export
 */
export const CSVApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Process and post CSV data for addresses and related information (office, shift, paths, mobscores)
         * @summary Upload CSV file
         * @param {UploadRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCsv(body: UploadRequest, options?: any) {
            return CSVApiFp(configuration).uploadCsv(body, options)(fetch, basePath);
        },
    };
};

/**
 * CSVApi - object-oriented interface
 * @export
 * @class CSVApi
 * @extends {BaseAPI}
 */
export class CSVApi extends BaseAPI {
    /**
     * Process and post CSV data for addresses and related information (office, shift, paths, mobscores)
     * @summary Upload CSV file
     * @param {UploadRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSVApi
     */
    public uploadCsv(body: UploadRequest, options?: any) {
        return CSVApiFp(this.configuration).uploadCsv(body, options)(this.fetch, this.basePath);
    }

}
/**
 * CompaniesApi - fetch parameter creator
 * @export
 */
export const CompaniesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete a existing company via id given in query
         * @summary delete a existing company
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanies(companyId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the companies in the database. You can filter for projects
         * @summary get the companies in the database
         * @param {number} [projId] Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(projId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * post a new company to the database
         * @summary post a new company to the database
         * @param {number} projId 
         * @param {CompanyWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanies(projId: number, body?: CompanyWithoutId, options: any = {}): FetchArgs {
            // verify required parameter 'projId' is not null or undefined
            if (projId === null || projId === undefined) {
                throw new RequiredError('projId','Required parameter projId was null or undefined when calling postCompanies.');
            }
            const localVarPath = `/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['ProjId'] = projId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * choose via id filter in query and manipulate the name through the request body
         * @summary update an existing company
         * @param {CompanyWithoutId} [body] 
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCompanies(body?: CompanyWithoutId, companyId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * delete a existing company via id given in query
         * @summary delete a existing company
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanies(companyId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompaniesApiFetchParamCreator(configuration).deleteCompanies(companyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get the companies in the database. You can filter for projects
         * @summary get the companies in the database
         * @param {number} [projId] Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(projId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Company>> {
            const localVarFetchArgs = CompaniesApiFetchParamCreator(configuration).getCompanies(projId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * post a new company to the database
         * @summary post a new company to the database
         * @param {number} projId 
         * @param {CompanyWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanies(projId: number, body?: CompanyWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompaniesApiFetchParamCreator(configuration).postCompanies(projId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * choose via id filter in query and manipulate the name through the request body
         * @summary update an existing company
         * @param {CompanyWithoutId} [body] 
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCompanies(body?: CompanyWithoutId, companyId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompaniesApiFetchParamCreator(configuration).putCompanies(body, companyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * delete a existing company via id given in query
         * @summary delete a existing company
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanies(companyId?: number, options?: any) {
            return CompaniesApiFp(configuration).deleteCompanies(companyId, options)(fetch, basePath);
        },
        /**
         * get the companies in the database. You can filter for projects
         * @summary get the companies in the database
         * @param {number} [projId] Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(projId?: number, options?: any) {
            return CompaniesApiFp(configuration).getCompanies(projId, options)(fetch, basePath);
        },
        /**
         * post a new company to the database
         * @summary post a new company to the database
         * @param {number} projId 
         * @param {CompanyWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanies(projId: number, body?: CompanyWithoutId, options?: any) {
            return CompaniesApiFp(configuration).postCompanies(projId, body, options)(fetch, basePath);
        },
        /**
         * choose via id filter in query and manipulate the name through the request body
         * @summary update an existing company
         * @param {CompanyWithoutId} [body] 
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCompanies(body?: CompanyWithoutId, companyId?: number, options?: any) {
            return CompaniesApiFp(configuration).putCompanies(body, companyId, options)(fetch, basePath);
        },
    };
};

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     * delete a existing company via id given in query
     * @summary delete a existing company
     * @param {number} [companyId] company identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public deleteCompanies(companyId?: number, options?: any) {
        return CompaniesApiFp(this.configuration).deleteCompanies(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * get the companies in the database. You can filter for projects
     * @summary get the companies in the database
     * @param {number} [projId] Identifier for projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getCompanies(projId?: number, options?: any) {
        return CompaniesApiFp(this.configuration).getCompanies(projId, options)(this.fetch, this.basePath);
    }

    /**
     * post a new company to the database
     * @summary post a new company to the database
     * @param {number} projId 
     * @param {CompanyWithoutId} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public postCompanies(projId: number, body?: CompanyWithoutId, options?: any) {
        return CompaniesApiFp(this.configuration).postCompanies(projId, body, options)(this.fetch, this.basePath);
    }

    /**
     * choose via id filter in query and manipulate the name through the request body
     * @summary update an existing company
     * @param {CompanyWithoutId} [body] 
     * @param {number} [companyId] company identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public putCompanies(body?: CompanyWithoutId, companyId?: number, options?: any) {
        return CompaniesApiFp(this.configuration).putCompanies(body, companyId, options)(this.fetch, this.basePath);
    }

}
/**
 * DownloadCSVApi - fetch parameter creator
 * @export
 */
export const DownloadCSVApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download CSV File with CleverRoute-Import Data
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsv(originIdFirst: number, originIdLast: number, options: any = {}): FetchArgs {
            // verify required parameter 'originIdFirst' is not null or undefined
            if (originIdFirst === null || originIdFirst === undefined) {
                throw new RequiredError('originIdFirst','Required parameter originIdFirst was null or undefined when calling downloadCsv.');
            }
            // verify required parameter 'originIdLast' is not null or undefined
            if (originIdLast === null || originIdLast === undefined) {
                throw new RequiredError('originIdLast','Required parameter originIdLast was null or undefined when calling downloadCsv.');
            }
            const localVarPath = `/download_csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (originIdFirst !== undefined) {
                localVarQueryParameter['originIdFirst'] = originIdFirst;
            }

            if (originIdLast !== undefined) {
                localVarQueryParameter['originIdLast'] = originIdLast;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadCSVApi - functional programming interface
 * @export
 */
export const DownloadCSVApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download CSV File with CleverRoute-Import Data
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsv(originIdFirst: number, originIdLast: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Blob> {
            const localVarFetchArgs = DownloadCSVApiFetchParamCreator(configuration).downloadCsv(originIdFirst, originIdLast, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DownloadCSVApi - factory interface
 * @export
 */
export const DownloadCSVApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Download CSV File with CleverRoute-Import Data
         * @param {number} originIdFirst 
         * @param {number} originIdLast 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsv(originIdFirst: number, originIdLast: number, options?: any) {
            return DownloadCSVApiFp(configuration).downloadCsv(originIdFirst, originIdLast, options)(fetch, basePath);
        },
    };
};

/**
 * DownloadCSVApi - object-oriented interface
 * @export
 * @class DownloadCSVApi
 * @extends {BaseAPI}
 */
export class DownloadCSVApi extends BaseAPI {
    /**
     * 
     * @summary Download CSV File with CleverRoute-Import Data
     * @param {number} originIdFirst 
     * @param {number} originIdLast 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadCSVApi
     */
    public downloadCsv(originIdFirst: number, originIdLast: number, options?: any) {
        return DownloadCSVApiFp(this.configuration).downloadCsv(originIdFirst, originIdLast, options)(this.fetch, this.basePath);
    }

}
/**
 * DownloadExcelApi - fetch parameter creator
 * @export
 */
export const DownloadExcelApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download Excel File with formatted comparison matrix
         * @param {DownloadExcelBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExcel(body: DownloadExcelBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling downloadExcel.');
            }
            const localVarPath = `/download_excel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DownloadExcelBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadExcelApi - functional programming interface
 * @export
 */
export const DownloadExcelApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download Excel File with formatted comparison matrix
         * @param {DownloadExcelBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExcel(body: DownloadExcelBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Blob> {
            const localVarFetchArgs = DownloadExcelApiFetchParamCreator(configuration).downloadExcel(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DownloadExcelApi - factory interface
 * @export
 */
export const DownloadExcelApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Download Excel File with formatted comparison matrix
         * @param {DownloadExcelBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExcel(body: DownloadExcelBody, options?: any) {
            return DownloadExcelApiFp(configuration).downloadExcel(body, options)(fetch, basePath);
        },
    };
};

/**
 * DownloadExcelApi - object-oriented interface
 * @export
 * @class DownloadExcelApi
 * @extends {BaseAPI}
 */
export class DownloadExcelApi extends BaseAPI {
    /**
     * 
     * @summary Download Excel File with formatted comparison matrix
     * @param {DownloadExcelBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadExcelApi
     */
    public downloadExcel(body: DownloadExcelBody, options?: any) {
        return DownloadExcelApiFp(this.configuration).downloadExcel(body, options)(this.fetch, this.basePath);
    }

}
/**
 * GeoPackageApi - fetch parameter creator
 * @export
 */
export const GeoPackageApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a GeoPackage file and all its associated layers
         * @param {number} geopackageId Identifier for the GeoPackage file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeopackage(geopackageId: number, options: any = {}): FetchArgs {
            // verify required parameter 'geopackageId' is not null or undefined
            if (geopackageId === null || geopackageId === undefined) {
                throw new RequiredError('geopackageId','Required parameter geopackageId was null or undefined when calling deleteGeopackage.');
            }
            const localVarPath = `/geopackage/{geopackageId}`
                .replace(`{${"geopackageId"}}`, encodeURIComponent(String(geopackageId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a marker icon image from a GeoPackage
         * @param {number} geopackageId ID of the GeoPackage
         * @param {string} iconId ID of the icon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackageIcon(geopackageId: number, iconId: string, options: any = {}): FetchArgs {
            // verify required parameter 'geopackageId' is not null or undefined
            if (geopackageId === null || geopackageId === undefined) {
                throw new RequiredError('geopackageId','Required parameter geopackageId was null or undefined when calling getGeopackageIcon.');
            }
            // verify required parameter 'iconId' is not null or undefined
            if (iconId === null || iconId === undefined) {
                throw new RequiredError('iconId','Required parameter iconId was null or undefined when calling getGeopackageIcon.');
            }
            const localVarPath = `/geopackage/icon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (geopackageId !== undefined) {
                localVarQueryParameter['geopackage_id'] = geopackageId;
            }

            if (iconId !== undefined) {
                localVarQueryParameter['icon_id'] = iconId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get layers from a GeoPackage file with enhanced metadata
         * @param {number} geopackageId Identifier for GeoPackage file
         * @param {boolean} [includeAttributes] Whether to include attribute schema information
         * @param {boolean} [includeSampleFeatures] Whether to include sample features
         * @param {number} [sampleCount] Number of sample features to include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackageLayers(geopackageId: number, includeAttributes?: boolean, includeSampleFeatures?: boolean, sampleCount?: number, options: any = {}): FetchArgs {
            // verify required parameter 'geopackageId' is not null or undefined
            if (geopackageId === null || geopackageId === undefined) {
                throw new RequiredError('geopackageId','Required parameter geopackageId was null or undefined when calling getGeopackageLayers.');
            }
            const localVarPath = `/geopackage/layers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (geopackageId !== undefined) {
                localVarQueryParameter['geopackageId'] = geopackageId;
            }

            if (includeAttributes !== undefined) {
                localVarQueryParameter['include_attributes'] = includeAttributes;
            }

            if (includeSampleFeatures !== undefined) {
                localVarQueryParameter['include_sample_features'] = includeSampleFeatures;
            }

            if (sampleCount !== undefined) {
                localVarQueryParameter['sample_count'] = sampleCount;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all GeoPackage files for a project with pagination and sorting
         * @param {number} projectId Identifier for project
         * @param {number} [limit] Maximum number of records to return
         * @param {number} [offset] Number of records to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackages(projectId: number, limit?: number, offset?: number, sortBy?: string, sortDir?: string, options: any = {}): FetchArgs {
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new RequiredError('projectId','Required parameter projectId was null or undefined when calling getGeopackages.');
            }
            const localVarPath = `/geopackage`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Serve an icon from the database by ID
         * @param {string} iconId ID of the icon in the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIconById(iconId: string, options: any = {}): FetchArgs {
            // verify required parameter 'iconId' is not null or undefined
            if (iconId === null || iconId === undefined) {
                throw new RequiredError('iconId','Required parameter iconId was null or undefined when calling getIconById.');
            }
            const localVarPath = `/geopackage/icon/{icon_id}`
                .replace(`{${"icon_id"}}`, encodeURIComponent(String(iconId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Serve an icon file from the filesystem
         * @param {string} iconPath Absolute path to the icon file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIconFileFromPath(iconPath: string, options: any = {}): FetchArgs {
            // verify required parameter 'iconPath' is not null or undefined
            if (iconPath === null || iconPath === undefined) {
                throw new RequiredError('iconPath','Required parameter iconPath was null or undefined when calling getIconFileFromPath.');
            }
            const localVarPath = `/geopackage/icon-file`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (iconPath !== undefined) {
                localVarQueryParameter['icon_path'] = iconPath;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get features from a layer with filtering, pagination and simplification
         * @param {number} layerId Identifier for layer
         * @param {string} [bbox] Bounding box for features (minX,minY,maxX,maxY)
         * @param {number} [limit] Maximum number of features to return
         * @param {number} [offset] Number of features to skip
         * @param {number} [simplify] Simplification tolerance for geometry (0-1)
         * @param {string} [filterExpr] Attribute filter expression (e.g. \&quot;name&#x3D;&#x27;Road 1&#x27; AND type&#x3D;&#x27;highway&#x27;\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerFeatures(layerId: number, bbox?: string, limit?: number, offset?: number, simplify?: number, filterExpr?: string, options: any = {}): FetchArgs {
            // verify required parameter 'layerId' is not null or undefined
            if (layerId === null || layerId === undefined) {
                throw new RequiredError('layerId','Required parameter layerId was null or undefined when calling getLayerFeatures.');
            }
            const localVarPath = `/geopackage/features`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (simplify !== undefined) {
                localVarQueryParameter['simplify'] = simplify;
            }

            if (filterExpr !== undefined) {
                localVarQueryParameter['filter_expr'] = filterExpr;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a GeoPackage file with validation and duplicate handling
         * @param {Blob} file 
         * @param {number} projectId Identifier for project
         * @param {boolean} [overwriteExisting] Whether to overwrite existing files with the same name
         * @param {boolean} [validateOnly] Whether to only validate the file without storing it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadGeopackage(file: Blob, projectId: number, overwriteExisting?: boolean, validateOnly?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadGeopackage.');
            }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new RequiredError('projectId','Required parameter projectId was null or undefined when calling uploadGeopackage.');
            }
            const localVarPath = `/geopackage`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (overwriteExisting !== undefined) {
                localVarQueryParameter['overwrite_existing'] = overwriteExisting;
            }

            if (validateOnly !== undefined) {
                localVarQueryParameter['validate_only'] = validateOnly;
            }

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeoPackageApi - functional programming interface
 * @export
 */
export const GeoPackageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a GeoPackage file and all its associated layers
         * @param {number} geopackageId Identifier for the GeoPackage file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeopackage(geopackageId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20017> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).deleteGeopackage(geopackageId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a marker icon image from a GeoPackage
         * @param {number} geopackageId ID of the GeoPackage
         * @param {string} iconId ID of the icon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackageIcon(geopackageId: number, iconId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Blob> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).getGeopackageIcon(geopackageId, iconId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get layers from a GeoPackage file with enhanced metadata
         * @param {number} geopackageId Identifier for GeoPackage file
         * @param {boolean} [includeAttributes] Whether to include attribute schema information
         * @param {boolean} [includeSampleFeatures] Whether to include sample features
         * @param {number} [sampleCount] Number of sample features to include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackageLayers(geopackageId: number, includeAttributes?: boolean, includeSampleFeatures?: boolean, sampleCount?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20012> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).getGeopackageLayers(geopackageId, includeAttributes, includeSampleFeatures, sampleCount, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all GeoPackage files for a project with pagination and sorting
         * @param {number} projectId Identifier for project
         * @param {number} [limit] Maximum number of records to return
         * @param {number} [offset] Number of records to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackages(projectId: number, limit?: number, offset?: number, sortBy?: string, sortDir?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20010> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).getGeopackages(projectId, limit, offset, sortBy, sortDir, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Serve an icon from the database by ID
         * @param {string} iconId ID of the icon in the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIconById(iconId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Blob> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).getIconById(iconId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Serve an icon file from the filesystem
         * @param {string} iconPath Absolute path to the icon file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIconFileFromPath(iconPath: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Blob> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).getIconFileFromPath(iconPath, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get features from a layer with filtering, pagination and simplification
         * @param {number} layerId Identifier for layer
         * @param {string} [bbox] Bounding box for features (minX,minY,maxX,maxY)
         * @param {number} [limit] Maximum number of features to return
         * @param {number} [offset] Number of features to skip
         * @param {number} [simplify] Simplification tolerance for geometry (0-1)
         * @param {string} [filterExpr] Attribute filter expression (e.g. \&quot;name&#x3D;&#x27;Road 1&#x27; AND type&#x3D;&#x27;highway&#x27;\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerFeatures(layerId: number, bbox?: string, limit?: number, offset?: number, simplify?: number, filterExpr?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20013> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).getLayerFeatures(layerId, bbox, limit, offset, simplify, filterExpr, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Upload a GeoPackage file with validation and duplicate handling
         * @param {Blob} file 
         * @param {number} projectId Identifier for project
         * @param {boolean} [overwriteExisting] Whether to overwrite existing files with the same name
         * @param {boolean} [validateOnly] Whether to only validate the file without storing it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadGeopackage(file: Blob, projectId: number, overwriteExisting?: boolean, validateOnly?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20011> {
            const localVarFetchArgs = GeoPackageApiFetchParamCreator(configuration).uploadGeopackage(file, projectId, overwriteExisting, validateOnly, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GeoPackageApi - factory interface
 * @export
 */
export const GeoPackageApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Delete a GeoPackage file and all its associated layers
         * @param {number} geopackageId Identifier for the GeoPackage file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeopackage(geopackageId: number, options?: any) {
            return GeoPackageApiFp(configuration).deleteGeopackage(geopackageId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a marker icon image from a GeoPackage
         * @param {number} geopackageId ID of the GeoPackage
         * @param {string} iconId ID of the icon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackageIcon(geopackageId: number, iconId: string, options?: any) {
            return GeoPackageApiFp(configuration).getGeopackageIcon(geopackageId, iconId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get layers from a GeoPackage file with enhanced metadata
         * @param {number} geopackageId Identifier for GeoPackage file
         * @param {boolean} [includeAttributes] Whether to include attribute schema information
         * @param {boolean} [includeSampleFeatures] Whether to include sample features
         * @param {number} [sampleCount] Number of sample features to include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackageLayers(geopackageId: number, includeAttributes?: boolean, includeSampleFeatures?: boolean, sampleCount?: number, options?: any) {
            return GeoPackageApiFp(configuration).getGeopackageLayers(geopackageId, includeAttributes, includeSampleFeatures, sampleCount, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all GeoPackage files for a project with pagination and sorting
         * @param {number} projectId Identifier for project
         * @param {number} [limit] Maximum number of records to return
         * @param {number} [offset] Number of records to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeopackages(projectId: number, limit?: number, offset?: number, sortBy?: string, sortDir?: string, options?: any) {
            return GeoPackageApiFp(configuration).getGeopackages(projectId, limit, offset, sortBy, sortDir, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Serve an icon from the database by ID
         * @param {string} iconId ID of the icon in the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIconById(iconId: string, options?: any) {
            return GeoPackageApiFp(configuration).getIconById(iconId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Serve an icon file from the filesystem
         * @param {string} iconPath Absolute path to the icon file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIconFileFromPath(iconPath: string, options?: any) {
            return GeoPackageApiFp(configuration).getIconFileFromPath(iconPath, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get features from a layer with filtering, pagination and simplification
         * @param {number} layerId Identifier for layer
         * @param {string} [bbox] Bounding box for features (minX,minY,maxX,maxY)
         * @param {number} [limit] Maximum number of features to return
         * @param {number} [offset] Number of features to skip
         * @param {number} [simplify] Simplification tolerance for geometry (0-1)
         * @param {string} [filterExpr] Attribute filter expression (e.g. \&quot;name&#x3D;&#x27;Road 1&#x27; AND type&#x3D;&#x27;highway&#x27;\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerFeatures(layerId: number, bbox?: string, limit?: number, offset?: number, simplify?: number, filterExpr?: string, options?: any) {
            return GeoPackageApiFp(configuration).getLayerFeatures(layerId, bbox, limit, offset, simplify, filterExpr, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Upload a GeoPackage file with validation and duplicate handling
         * @param {Blob} file 
         * @param {number} projectId Identifier for project
         * @param {boolean} [overwriteExisting] Whether to overwrite existing files with the same name
         * @param {boolean} [validateOnly] Whether to only validate the file without storing it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadGeopackage(file: Blob, projectId: number, overwriteExisting?: boolean, validateOnly?: boolean, options?: any) {
            return GeoPackageApiFp(configuration).uploadGeopackage(file, projectId, overwriteExisting, validateOnly, options)(fetch, basePath);
        },
    };
};

/**
 * GeoPackageApi - object-oriented interface
 * @export
 * @class GeoPackageApi
 * @extends {BaseAPI}
 */
export class GeoPackageApi extends BaseAPI {
    /**
     * 
     * @summary Delete a GeoPackage file and all its associated layers
     * @param {number} geopackageId Identifier for the GeoPackage file to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public deleteGeopackage(geopackageId: number, options?: any) {
        return GeoPackageApiFp(this.configuration).deleteGeopackage(geopackageId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a marker icon image from a GeoPackage
     * @param {number} geopackageId ID of the GeoPackage
     * @param {string} iconId ID of the icon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public getGeopackageIcon(geopackageId: number, iconId: string, options?: any) {
        return GeoPackageApiFp(this.configuration).getGeopackageIcon(geopackageId, iconId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get layers from a GeoPackage file with enhanced metadata
     * @param {number} geopackageId Identifier for GeoPackage file
     * @param {boolean} [includeAttributes] Whether to include attribute schema information
     * @param {boolean} [includeSampleFeatures] Whether to include sample features
     * @param {number} [sampleCount] Number of sample features to include
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public getGeopackageLayers(geopackageId: number, includeAttributes?: boolean, includeSampleFeatures?: boolean, sampleCount?: number, options?: any) {
        return GeoPackageApiFp(this.configuration).getGeopackageLayers(geopackageId, includeAttributes, includeSampleFeatures, sampleCount, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all GeoPackage files for a project with pagination and sorting
     * @param {number} projectId Identifier for project
     * @param {number} [limit] Maximum number of records to return
     * @param {number} [offset] Number of records to skip
     * @param {string} [sortBy] Field to sort by
     * @param {string} [sortDir] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public getGeopackages(projectId: number, limit?: number, offset?: number, sortBy?: string, sortDir?: string, options?: any) {
        return GeoPackageApiFp(this.configuration).getGeopackages(projectId, limit, offset, sortBy, sortDir, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Serve an icon from the database by ID
     * @param {string} iconId ID of the icon in the database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public getIconById(iconId: string, options?: any) {
        return GeoPackageApiFp(this.configuration).getIconById(iconId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Serve an icon file from the filesystem
     * @param {string} iconPath Absolute path to the icon file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public getIconFileFromPath(iconPath: string, options?: any) {
        return GeoPackageApiFp(this.configuration).getIconFileFromPath(iconPath, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get features from a layer with filtering, pagination and simplification
     * @param {number} layerId Identifier for layer
     * @param {string} [bbox] Bounding box for features (minX,minY,maxX,maxY)
     * @param {number} [limit] Maximum number of features to return
     * @param {number} [offset] Number of features to skip
     * @param {number} [simplify] Simplification tolerance for geometry (0-1)
     * @param {string} [filterExpr] Attribute filter expression (e.g. \&quot;name&#x3D;&#x27;Road 1&#x27; AND type&#x3D;&#x27;highway&#x27;\&quot;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public getLayerFeatures(layerId: number, bbox?: string, limit?: number, offset?: number, simplify?: number, filterExpr?: string, options?: any) {
        return GeoPackageApiFp(this.configuration).getLayerFeatures(layerId, bbox, limit, offset, simplify, filterExpr, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Upload a GeoPackage file with validation and duplicate handling
     * @param {Blob} file 
     * @param {number} projectId Identifier for project
     * @param {boolean} [overwriteExisting] Whether to overwrite existing files with the same name
     * @param {boolean} [validateOnly] Whether to only validate the file without storing it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoPackageApi
     */
    public uploadGeopackage(file: Blob, projectId: number, overwriteExisting?: boolean, validateOnly?: boolean, options?: any) {
        return GeoPackageApiFp(this.configuration).uploadGeopackage(file, projectId, overwriteExisting, validateOnly, options)(this.fetch, this.basePath);
    }

}
/**
 * GeocodingApi - fetch parameter creator
 * @export
 */
export const GeocodingApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets geo-data from cleverroute for all addresses within the specified ID range
         * @summary Get geocoding for a range of addresses
         * @param {number} originIdFirst First address ID in the range
         * @param {number} originIdLast Last address ID in the range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGeocodingGet(originIdFirst: number, originIdLast: number, options: any = {}): FetchArgs {
            // verify required parameter 'originIdFirst' is not null or undefined
            if (originIdFirst === null || originIdFirst === undefined) {
                throw new RequiredError('originIdFirst','Required parameter originIdFirst was null or undefined when calling bulkGeocodingGet.');
            }
            // verify required parameter 'originIdLast' is not null or undefined
            if (originIdLast === null || originIdLast === undefined) {
                throw new RequiredError('originIdLast','Required parameter originIdLast was null or undefined when calling bulkGeocodingGet.');
            }
            const localVarPath = `/geocoding/bulk`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (originIdFirst !== undefined) {
                localVarQueryParameter['originIdFirst'] = originIdFirst;
            }

            if (originIdLast !== undefined) {
                localVarQueryParameter['originIdLast'] = originIdLast;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get geocoding for an adress
         * @param {number} adressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodingGet(adressId: number, options: any = {}): FetchArgs {
            // verify required parameter 'adressId' is not null or undefined
            if (adressId === null || adressId === undefined) {
                throw new RequiredError('adressId','Required parameter adressId was null or undefined when calling geocodingGet.');
            }
            const localVarPath = `/geocoding`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (adressId !== undefined) {
                localVarQueryParameter['adress_id'] = adressId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeocodingApi - functional programming interface
 * @export
 */
export const GeocodingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets geo-data from cleverroute for all addresses within the specified ID range
         * @summary Get geocoding for a range of addresses
         * @param {number} originIdFirst First address ID in the range
         * @param {number} originIdLast Last address ID in the range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGeocodingGet(originIdFirst: number, originIdLast: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<InlineResponse2009>> {
            const localVarFetchArgs = GeocodingApiFetchParamCreator(configuration).bulkGeocodingGet(originIdFirst, originIdLast, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get geocoding for an adress
         * @param {number} adressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodingGet(adressId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportResponse> {
            const localVarFetchArgs = GeocodingApiFetchParamCreator(configuration).geocodingGet(adressId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GeocodingApi - factory interface
 * @export
 */
export const GeocodingApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Gets geo-data from cleverroute for all addresses within the specified ID range
         * @summary Get geocoding for a range of addresses
         * @param {number} originIdFirst First address ID in the range
         * @param {number} originIdLast Last address ID in the range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGeocodingGet(originIdFirst: number, originIdLast: number, options?: any) {
            return GeocodingApiFp(configuration).bulkGeocodingGet(originIdFirst, originIdLast, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get geocoding for an adress
         * @param {number} adressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodingGet(adressId: number, options?: any) {
            return GeocodingApiFp(configuration).geocodingGet(adressId, options)(fetch, basePath);
        },
    };
};

/**
 * GeocodingApi - object-oriented interface
 * @export
 * @class GeocodingApi
 * @extends {BaseAPI}
 */
export class GeocodingApi extends BaseAPI {
    /**
     * Gets geo-data from cleverroute for all addresses within the specified ID range
     * @summary Get geocoding for a range of addresses
     * @param {number} originIdFirst First address ID in the range
     * @param {number} originIdLast Last address ID in the range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeocodingApi
     */
    public bulkGeocodingGet(originIdFirst: number, originIdLast: number, options?: any) {
        return GeocodingApiFp(this.configuration).bulkGeocodingGet(originIdFirst, originIdLast, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get geocoding for an adress
     * @param {number} adressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeocodingApi
     */
    public geocodingGet(adressId: number, options?: any) {
        return GeocodingApiFp(this.configuration).geocodingGet(adressId, options)(this.fetch, this.basePath);
    }

}
/**
 * ImportsApi - fetch parameter creator
 * @export
 */
export const ImportsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The requests to the cr-API, regarding this import, will be stopped immediatly after the request has been successfully executed. There is the additional option to delete the stored responses of the cr-API from requests, that were already sent.
         * @summary Puts a running import out of the request-queue.
         * @param {number} importId 
         * @param {boolean} deleteData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDelete(importId: number, deleteData: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'importId' is not null or undefined
            if (importId === null || importId === undefined) {
                throw new RequiredError('importId','Required parameter importId was null or undefined when calling importDelete.');
            }
            // verify required parameter 'deleteData' is not null or undefined
            if (deleteData === null || deleteData === undefined) {
                throw new RequiredError('deleteData','Required parameter deleteData was null or undefined when calling importDelete.');
            }
            const localVarPath = `/import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (importId !== undefined) {
                localVarQueryParameter['importId'] = importId;
            }

            if (deleteData !== undefined) {
                localVarQueryParameter['deleteData'] = deleteData;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will return a list of the CleverRoute-imports currently in queue. Put a valid id in query to get information about a specific running import.
         * @summary Fetch running imports.
         * @param {number} [importId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGet(importId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (importId !== undefined) {
                localVarQueryParameter['importId'] = importId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts a new import, that will run in the background as a seperate thread (if the Cr-API allows for the additional traffic). As the import runs, the data returned from CleverRoute will be stored in the database and is then available for analysis.
         * @summary Posts a new import in queue.
         * @param {ImportSettings} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPost(body?: ImportSettings, options: any = {}): FetchArgs {
            const localVarPath = `/import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ImportSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportsApi - functional programming interface
 * @export
 */
export const ImportsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * The requests to the cr-API, regarding this import, will be stopped immediatly after the request has been successfully executed. There is the additional option to delete the stored responses of the cr-API from requests, that were already sent.
         * @summary Puts a running import out of the request-queue.
         * @param {number} importId 
         * @param {boolean} deleteData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDelete(importId: number, deleteData: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportResponse> {
            const localVarFetchArgs = ImportsApiFetchParamCreator(configuration).importDelete(importId, deleteData, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Will return a list of the CleverRoute-imports currently in queue. Put a valid id in query to get information about a specific running import.
         * @summary Fetch running imports.
         * @param {number} [importId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGet(importId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportResponse> {
            const localVarFetchArgs = ImportsApiFetchParamCreator(configuration).importGet(importId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Posts a new import, that will run in the background as a seperate thread (if the Cr-API allows for the additional traffic). As the import runs, the data returned from CleverRoute will be stored in the database and is then available for analysis.
         * @summary Posts a new import in queue.
         * @param {ImportSettings} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPost(body?: ImportSettings, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportResponse> {
            const localVarFetchArgs = ImportsApiFetchParamCreator(configuration).importPost(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ImportsApi - factory interface
 * @export
 */
export const ImportsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * The requests to the cr-API, regarding this import, will be stopped immediatly after the request has been successfully executed. There is the additional option to delete the stored responses of the cr-API from requests, that were already sent.
         * @summary Puts a running import out of the request-queue.
         * @param {number} importId 
         * @param {boolean} deleteData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDelete(importId: number, deleteData: boolean, options?: any) {
            return ImportsApiFp(configuration).importDelete(importId, deleteData, options)(fetch, basePath);
        },
        /**
         * Will return a list of the CleverRoute-imports currently in queue. Put a valid id in query to get information about a specific running import.
         * @summary Fetch running imports.
         * @param {number} [importId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGet(importId?: number, options?: any) {
            return ImportsApiFp(configuration).importGet(importId, options)(fetch, basePath);
        },
        /**
         * Posts a new import, that will run in the background as a seperate thread (if the Cr-API allows for the additional traffic). As the import runs, the data returned from CleverRoute will be stored in the database and is then available for analysis.
         * @summary Posts a new import in queue.
         * @param {ImportSettings} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPost(body?: ImportSettings, options?: any) {
            return ImportsApiFp(configuration).importPost(body, options)(fetch, basePath);
        },
    };
};

/**
 * ImportsApi - object-oriented interface
 * @export
 * @class ImportsApi
 * @extends {BaseAPI}
 */
export class ImportsApi extends BaseAPI {
    /**
     * The requests to the cr-API, regarding this import, will be stopped immediatly after the request has been successfully executed. There is the additional option to delete the stored responses of the cr-API from requests, that were already sent.
     * @summary Puts a running import out of the request-queue.
     * @param {number} importId 
     * @param {boolean} deleteData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    public importDelete(importId: number, deleteData: boolean, options?: any) {
        return ImportsApiFp(this.configuration).importDelete(importId, deleteData, options)(this.fetch, this.basePath);
    }

    /**
     * Will return a list of the CleverRoute-imports currently in queue. Put a valid id in query to get information about a specific running import.
     * @summary Fetch running imports.
     * @param {number} [importId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    public importGet(importId?: number, options?: any) {
        return ImportsApiFp(this.configuration).importGet(importId, options)(this.fetch, this.basePath);
    }

    /**
     * Posts a new import, that will run in the background as a seperate thread (if the Cr-API allows for the additional traffic). As the import runs, the data returned from CleverRoute will be stored in the database and is then available for analysis.
     * @summary Posts a new import in queue.
     * @param {ImportSettings} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    public importPost(body?: ImportSettings, options?: any) {
        return ImportsApiFp(this.configuration).importPost(body, options)(this.fetch, this.basePath);
    }

}
/**
 * MetricsApi - fetch parameter creator
 * @export
 */
export const MetricsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get metrics for a given project, company, office and transport. Note, that the incoming data can change, depending on if you give a metrictype or not. If you don't give a metric type, all metrics are returned in a dict
         * @summary get metrics for transports from the database
         * @param {number} projId Identifier for projects
         * @param {number} companyId company identifier
         * @param {number} officeId Identifier for offices
         * @param {string} transport type of transport
         * @param {string} [metricType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(projId: number, companyId: number, officeId: number, transport: string, metricType?: string, options: any = {}): FetchArgs {
            // verify required parameter 'projId' is not null or undefined
            if (projId === null || projId === undefined) {
                throw new RequiredError('projId','Required parameter projId was null or undefined when calling getMetrics.');
            }
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getMetrics.');
            }
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getMetrics.');
            }
            // verify required parameter 'transport' is not null or undefined
            if (transport === null || transport === undefined) {
                throw new RequiredError('transport','Required parameter transport was null or undefined when calling getMetrics.');
            }
            const localVarPath = `/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            if (transport !== undefined) {
                localVarQueryParameter['transport'] = transport;
            }

            if (metricType !== undefined) {
                localVarQueryParameter['metricType'] = metricType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * get metrics for a given project, company, office and transport. Note, that the incoming data can change, depending on if you give a metrictype or not. If you don't give a metric type, all metrics are returned in a dict
         * @summary get metrics for transports from the database
         * @param {number} projId Identifier for projects
         * @param {number} companyId company identifier
         * @param {number} officeId Identifier for offices
         * @param {string} transport type of transport
         * @param {string} [metricType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(projId: number, companyId: number, officeId: number, transport: string, metricType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MetricData> {
            const localVarFetchArgs = MetricsApiFetchParamCreator(configuration).getMetrics(projId, companyId, officeId, transport, metricType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * get metrics for a given project, company, office and transport. Note, that the incoming data can change, depending on if you give a metrictype or not. If you don't give a metric type, all metrics are returned in a dict
         * @summary get metrics for transports from the database
         * @param {number} projId Identifier for projects
         * @param {number} companyId company identifier
         * @param {number} officeId Identifier for offices
         * @param {string} transport type of transport
         * @param {string} [metricType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(projId: number, companyId: number, officeId: number, transport: string, metricType?: string, options?: any) {
            return MetricsApiFp(configuration).getMetrics(projId, companyId, officeId, transport, metricType, options)(fetch, basePath);
        },
    };
};

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     * get metrics for a given project, company, office and transport. Note, that the incoming data can change, depending on if you give a metrictype or not. If you don't give a metric type, all metrics are returned in a dict
     * @summary get metrics for transports from the database
     * @param {number} projId Identifier for projects
     * @param {number} companyId company identifier
     * @param {number} officeId Identifier for offices
     * @param {string} transport type of transport
     * @param {string} [metricType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getMetrics(projId: number, companyId: number, officeId: number, transport: string, metricType?: string, options?: any) {
        return MetricsApiFp(this.configuration).getMetrics(projId, companyId, officeId, transport, metricType, options)(this.fetch, this.basePath);
    }

}
/**
 * MobscoreSettingApi - fetch parameter creator
 * @export
 */
export const MobscoreSettingApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get mobscore settings for mobscore calculation
         * @summary get mobscore settings
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobscoreGet(officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling mobscoreGet.');
            }
            const localVarPath = `/mobscore`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * set new mobscore setting
         * @summary set new mobscore setting
         * @param {number} officeId 
         * @param {MobScore} [body] mobscore settings to be put, every column must be filled, all weights must add up to 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobscorePut(officeId: number, body?: MobScore, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling mobscorePut.');
            }
            const localVarPath = `/mobscore`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MobScore" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post an office to the database
         * @param {number} officeId 
         * @param {MobScore} [body] mobscore settings to be posted, every weight column must be filled, all weights must add up to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMobscoreSettings(officeId: number, body?: MobScore, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling postMobscoreSettings.');
            }
            const localVarPath = `/mobscore`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MobScore" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobscoreSettingApi - functional programming interface
 * @export
 */
export const MobscoreSettingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * get mobscore settings for mobscore calculation
         * @summary get mobscore settings
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobscoreGet(officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MobScore> {
            const localVarFetchArgs = MobscoreSettingApiFetchParamCreator(configuration).mobscoreGet(officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * set new mobscore setting
         * @summary set new mobscore setting
         * @param {number} officeId 
         * @param {MobScore} [body] mobscore settings to be put, every column must be filled, all weights must add up to 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobscorePut(officeId: number, body?: MobScore, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MobScore> {
            const localVarFetchArgs = MobscoreSettingApiFetchParamCreator(configuration).mobscorePut(officeId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post an office to the database
         * @param {number} officeId 
         * @param {MobScore} [body] mobscore settings to be posted, every weight column must be filled, all weights must add up to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMobscoreSettings(officeId: number, body?: MobScore, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MobScore> {
            const localVarFetchArgs = MobscoreSettingApiFetchParamCreator(configuration).postMobscoreSettings(officeId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MobscoreSettingApi - factory interface
 * @export
 */
export const MobscoreSettingApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * get mobscore settings for mobscore calculation
         * @summary get mobscore settings
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobscoreGet(officeId: number, options?: any) {
            return MobscoreSettingApiFp(configuration).mobscoreGet(officeId, options)(fetch, basePath);
        },
        /**
         * set new mobscore setting
         * @summary set new mobscore setting
         * @param {number} officeId 
         * @param {MobScore} [body] mobscore settings to be put, every column must be filled, all weights must add up to 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobscorePut(officeId: number, body?: MobScore, options?: any) {
            return MobscoreSettingApiFp(configuration).mobscorePut(officeId, body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post an office to the database
         * @param {number} officeId 
         * @param {MobScore} [body] mobscore settings to be posted, every weight column must be filled, all weights must add up to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMobscoreSettings(officeId: number, body?: MobScore, options?: any) {
            return MobscoreSettingApiFp(configuration).postMobscoreSettings(officeId, body, options)(fetch, basePath);
        },
    };
};

/**
 * MobscoreSettingApi - object-oriented interface
 * @export
 * @class MobscoreSettingApi
 * @extends {BaseAPI}
 */
export class MobscoreSettingApi extends BaseAPI {
    /**
     * get mobscore settings for mobscore calculation
     * @summary get mobscore settings
     * @param {number} officeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobscoreSettingApi
     */
    public mobscoreGet(officeId: number, options?: any) {
        return MobscoreSettingApiFp(this.configuration).mobscoreGet(officeId, options)(this.fetch, this.basePath);
    }

    /**
     * set new mobscore setting
     * @summary set new mobscore setting
     * @param {number} officeId 
     * @param {MobScore} [body] mobscore settings to be put, every column must be filled, all weights must add up to 100
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobscoreSettingApi
     */
    public mobscorePut(officeId: number, body?: MobScore, options?: any) {
        return MobscoreSettingApiFp(this.configuration).mobscorePut(officeId, body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post an office to the database
     * @param {number} officeId 
     * @param {MobScore} [body] mobscore settings to be posted, every weight column must be filled, all weights must add up to 1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobscoreSettingApi
     */
    public postMobscoreSettings(officeId: number, body?: MobScore, options?: any) {
        return MobscoreSettingApiFp(this.configuration).postMobscoreSettings(officeId, body, options)(this.fetch, this.basePath);
    }

}
/**
 * OfficeParametersApi - fetch parameter creator
 * @export
 */
export const OfficeParametersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes office-specific parameter, system falls back to defaults
         * @summary delete specific transport parameter
         * @param {number} officeId ID of the office
         * @param {string} transportType Type of transport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfficeParameter(officeId: number, transportType: string, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling deleteOfficeParameter.');
            }
            // verify required parameter 'transportType' is not null or undefined
            if (transportType === null || transportType === undefined) {
                throw new RequiredError('transportType','Required parameter transportType was null or undefined when calling deleteOfficeParameter.');
            }
            const localVarPath = `/office-parameters/office/{officeId}/transport/{transportType}`
                .replace(`{${"officeId"}}`, encodeURIComponent(String(officeId)))
                .replace(`{${"transportType"}}`, encodeURIComponent(String(transportType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete office parameters from the database
         * @param {number} id Identifier for office parameters to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfficeParameters(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteOfficeParameters.');
            }
            const localVarPath = `/office-parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns parameter for specific transport type, falls back to default if not found
         * @summary get specific transport parameter for an office
         * @param {number} officeId ID of the office
         * @param {string} transportType Type of transport (car, bike, train, etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeParameterByTransport(officeId: number, transportType: string, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getOfficeParameterByTransport.');
            }
            // verify required parameter 'transportType' is not null or undefined
            if (transportType === null || transportType === undefined) {
                throw new RequiredError('transportType','Required parameter transportType was null or undefined when calling getOfficeParameterByTransport.');
            }
            const localVarPath = `/office-parameters/office/{officeId}/transport/{transportType}`
                .replace(`{${"officeId"}}`, encodeURIComponent(String(officeId)))
                .replace(`{${"transportType"}}`, encodeURIComponent(String(transportType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get office parameters from database
         * @param {number} [id] Identifier for office parameters
         * @param {number} [officeId] Office identifier to filter parameters
         * @param {string} [transportType] Transport type to filter parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeParameters(id?: number, officeId?: number, transportType?: string, options: any = {}): FetchArgs {
            const localVarPath = `/office-parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            if (transportType !== undefined) {
                localVarQueryParameter['transportType'] = transportType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates office parameters using default values. Only creates if parameters don't already exist.
         * @summary initialize office parameters from defaults
         * @param {number} officeId ID of the office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeOfficeParametersEndpoint(officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling initializeOfficeParametersEndpoint.');
            }
            const localVarPath = `/office-parameters/office/{officeId}/initialize`
                .replace(`{${"officeId"}}`, encodeURIComponent(String(officeId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * specify what office parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing office parameter in the database
         * @param {OfficeParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officeParametersPut(body: OfficeParametersWithId, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling officeParametersPut.');
            }
            const localVarPath = `/office-parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OfficeParametersWithId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post office parameters for a new transport type to the database
         * @param {OfficeParametersWithoutId} [body] the office parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOfficeParameters(body?: OfficeParametersWithoutId, options: any = {}): FetchArgs {
            const localVarPath = `/office-parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OfficeParametersWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfficeParametersApi - functional programming interface
 * @export
 */
export const OfficeParametersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes office-specific parameter, system falls back to defaults
         * @summary delete specific transport parameter
         * @param {number} officeId ID of the office
         * @param {string} transportType Type of transport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfficeParameter(officeId: number, transportType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20019> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).deleteOfficeParameter(officeId, transportType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary delete office parameters from the database
         * @param {number} id Identifier for office parameters to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfficeParameters(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20018> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).deleteOfficeParameters(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns parameter for specific transport type, falls back to default if not found
         * @summary get specific transport parameter for an office
         * @param {number} officeId ID of the office
         * @param {string} transportType Type of transport (car, bike, train, etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeParameterByTransport(officeId: number, transportType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OfficeParametersWithId> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).getOfficeParameterByTransport(officeId, transportType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get office parameters from database
         * @param {number} [id] Identifier for office parameters
         * @param {number} [officeId] Office identifier to filter parameters
         * @param {string} [transportType] Transport type to filter parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeParameters(id?: number, officeId?: number, transportType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<OfficeParametersWithId>> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).getOfficeParameters(id, officeId, transportType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates office parameters using default values. Only creates if parameters don't already exist.
         * @summary initialize office parameters from defaults
         * @param {number} officeId ID of the office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeOfficeParametersEndpoint(officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2013> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).initializeOfficeParametersEndpoint(officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * specify what office parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing office parameter in the database
         * @param {OfficeParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officeParametersPut(body: OfficeParametersWithId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OfficeParametersWithId> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).officeParametersPut(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post office parameters for a new transport type to the database
         * @param {OfficeParametersWithoutId} [body] the office parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOfficeParameters(body?: OfficeParametersWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OfficeParametersWithId> {
            const localVarFetchArgs = OfficeParametersApiFetchParamCreator(configuration).postOfficeParameters(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * OfficeParametersApi - factory interface
 * @export
 */
export const OfficeParametersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Deletes office-specific parameter, system falls back to defaults
         * @summary delete specific transport parameter
         * @param {number} officeId ID of the office
         * @param {string} transportType Type of transport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfficeParameter(officeId: number, transportType: string, options?: any) {
            return OfficeParametersApiFp(configuration).deleteOfficeParameter(officeId, transportType, options)(fetch, basePath);
        },
        /**
         * 
         * @summary delete office parameters from the database
         * @param {number} id Identifier for office parameters to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfficeParameters(id: number, options?: any) {
            return OfficeParametersApiFp(configuration).deleteOfficeParameters(id, options)(fetch, basePath);
        },
        /**
         * Returns parameter for specific transport type, falls back to default if not found
         * @summary get specific transport parameter for an office
         * @param {number} officeId ID of the office
         * @param {string} transportType Type of transport (car, bike, train, etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeParameterByTransport(officeId: number, transportType: string, options?: any) {
            return OfficeParametersApiFp(configuration).getOfficeParameterByTransport(officeId, transportType, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get office parameters from database
         * @param {number} [id] Identifier for office parameters
         * @param {number} [officeId] Office identifier to filter parameters
         * @param {string} [transportType] Transport type to filter parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeParameters(id?: number, officeId?: number, transportType?: string, options?: any) {
            return OfficeParametersApiFp(configuration).getOfficeParameters(id, officeId, transportType, options)(fetch, basePath);
        },
        /**
         * Creates office parameters using default values. Only creates if parameters don't already exist.
         * @summary initialize office parameters from defaults
         * @param {number} officeId ID of the office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeOfficeParametersEndpoint(officeId: number, options?: any) {
            return OfficeParametersApiFp(configuration).initializeOfficeParametersEndpoint(officeId, options)(fetch, basePath);
        },
        /**
         * specify what office parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing office parameter in the database
         * @param {OfficeParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officeParametersPut(body: OfficeParametersWithId, options?: any) {
            return OfficeParametersApiFp(configuration).officeParametersPut(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post office parameters for a new transport type to the database
         * @param {OfficeParametersWithoutId} [body] the office parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOfficeParameters(body?: OfficeParametersWithoutId, options?: any) {
            return OfficeParametersApiFp(configuration).postOfficeParameters(body, options)(fetch, basePath);
        },
    };
};

/**
 * OfficeParametersApi - object-oriented interface
 * @export
 * @class OfficeParametersApi
 * @extends {BaseAPI}
 */
export class OfficeParametersApi extends BaseAPI {
    /**
     * Deletes office-specific parameter, system falls back to defaults
     * @summary delete specific transport parameter
     * @param {number} officeId ID of the office
     * @param {string} transportType Type of transport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public deleteOfficeParameter(officeId: number, transportType: string, options?: any) {
        return OfficeParametersApiFp(this.configuration).deleteOfficeParameter(officeId, transportType, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary delete office parameters from the database
     * @param {number} id Identifier for office parameters to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public deleteOfficeParameters(id: number, options?: any) {
        return OfficeParametersApiFp(this.configuration).deleteOfficeParameters(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns parameter for specific transport type, falls back to default if not found
     * @summary get specific transport parameter for an office
     * @param {number} officeId ID of the office
     * @param {string} transportType Type of transport (car, bike, train, etc.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public getOfficeParameterByTransport(officeId: number, transportType: string, options?: any) {
        return OfficeParametersApiFp(this.configuration).getOfficeParameterByTransport(officeId, transportType, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get office parameters from database
     * @param {number} [id] Identifier for office parameters
     * @param {number} [officeId] Office identifier to filter parameters
     * @param {string} [transportType] Transport type to filter parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public getOfficeParameters(id?: number, officeId?: number, transportType?: string, options?: any) {
        return OfficeParametersApiFp(this.configuration).getOfficeParameters(id, officeId, transportType, options)(this.fetch, this.basePath);
    }

    /**
     * Creates office parameters using default values. Only creates if parameters don't already exist.
     * @summary initialize office parameters from defaults
     * @param {number} officeId ID of the office
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public initializeOfficeParametersEndpoint(officeId: number, options?: any) {
        return OfficeParametersApiFp(this.configuration).initializeOfficeParametersEndpoint(officeId, options)(this.fetch, this.basePath);
    }

    /**
     * specify what office parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
     * @summary manipulate an existing office parameter in the database
     * @param {OfficeParametersWithId} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public officeParametersPut(body: OfficeParametersWithId, options?: any) {
        return OfficeParametersApiFp(this.configuration).officeParametersPut(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post office parameters for a new transport type to the database
     * @param {OfficeParametersWithoutId} [body] the office parameters that are to be inserted into the database, do NOT include the id in the request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeParametersApi
     */
    public postOfficeParameters(body?: OfficeParametersWithoutId, options?: any) {
        return OfficeParametersApiFp(this.configuration).postOfficeParameters(body, options)(this.fetch, this.basePath);
    }

}
/**
 * OfficesApi - fetch parameter creator
 * @export
 */
export const OfficesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * filter for projects and companies
         * @summary get offices from database
         * @param {number} [projId] Identifier for projects
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffices(projId?: number, companyId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/offices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * filter for address id
         * @summary get address id for office from database
         * @param {number} officeId Identifier for office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficesAddressId(officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getOfficesAddressId.');
            }
            const localVarPath = `/offices/id`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing office from the database via the office id
         * @summary delete an existing office from the database
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officesDelete(officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling officesDelete.');
            }
            const localVarPath = `/offices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * specify what office to manipulate via the identifier in the query and post the new office in the requestbody
         * @summary update an existing office in the database
         * @param {number} officeId 
         * @param {OfficesWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officesPut(officeId: number, body?: OfficesWithoutId, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling officesPut.');
            }
            const localVarPath = `/offices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OfficesWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post an office to the database
         * @param {number} companyId 
         * @param {OfficesWithoutId} [body] the office that is to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOffices(companyId: number, body?: OfficesWithoutId, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling postOffices.');
            }
            const localVarPath = `/offices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OfficesWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfficesApi - functional programming interface
 * @export
 */
export const OfficesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * filter for projects and companies
         * @summary get offices from database
         * @param {number} [projId] Identifier for projects
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffices(projId?: number, companyId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<OfficeApiView>> {
            const localVarFetchArgs = OfficesApiFetchParamCreator(configuration).getOffices(projId, companyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * filter for address id
         * @summary get address id for office from database
         * @param {number} officeId Identifier for office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficesAddressId(officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Offices>> {
            const localVarFetchArgs = OfficesApiFetchParamCreator(configuration).getOfficesAddressId(officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * delete an existing office from the database via the office id
         * @summary delete an existing office from the database
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officesDelete(officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Offices> {
            const localVarFetchArgs = OfficesApiFetchParamCreator(configuration).officesDelete(officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * specify what office to manipulate via the identifier in the query and post the new office in the requestbody
         * @summary update an existing office in the database
         * @param {number} officeId 
         * @param {OfficesWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officesPut(officeId: number, body?: OfficesWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Offices> {
            const localVarFetchArgs = OfficesApiFetchParamCreator(configuration).officesPut(officeId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post an office to the database
         * @param {number} companyId 
         * @param {OfficesWithoutId} [body] the office that is to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOffices(companyId: number, body?: OfficesWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Offices> {
            const localVarFetchArgs = OfficesApiFetchParamCreator(configuration).postOffices(companyId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * OfficesApi - factory interface
 * @export
 */
export const OfficesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * filter for projects and companies
         * @summary get offices from database
         * @param {number} [projId] Identifier for projects
         * @param {number} [companyId] company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffices(projId?: number, companyId?: number, options?: any) {
            return OfficesApiFp(configuration).getOffices(projId, companyId, options)(fetch, basePath);
        },
        /**
         * filter for address id
         * @summary get address id for office from database
         * @param {number} officeId Identifier for office
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficesAddressId(officeId: number, options?: any) {
            return OfficesApiFp(configuration).getOfficesAddressId(officeId, options)(fetch, basePath);
        },
        /**
         * delete an existing office from the database via the office id
         * @summary delete an existing office from the database
         * @param {number} officeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officesDelete(officeId: number, options?: any) {
            return OfficesApiFp(configuration).officesDelete(officeId, options)(fetch, basePath);
        },
        /**
         * specify what office to manipulate via the identifier in the query and post the new office in the requestbody
         * @summary update an existing office in the database
         * @param {number} officeId 
         * @param {OfficesWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officesPut(officeId: number, body?: OfficesWithoutId, options?: any) {
            return OfficesApiFp(configuration).officesPut(officeId, body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post an office to the database
         * @param {number} companyId 
         * @param {OfficesWithoutId} [body] the office that is to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOffices(companyId: number, body?: OfficesWithoutId, options?: any) {
            return OfficesApiFp(configuration).postOffices(companyId, body, options)(fetch, basePath);
        },
    };
};

/**
 * OfficesApi - object-oriented interface
 * @export
 * @class OfficesApi
 * @extends {BaseAPI}
 */
export class OfficesApi extends BaseAPI {
    /**
     * filter for projects and companies
     * @summary get offices from database
     * @param {number} [projId] Identifier for projects
     * @param {number} [companyId] company identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficesApi
     */
    public getOffices(projId?: number, companyId?: number, options?: any) {
        return OfficesApiFp(this.configuration).getOffices(projId, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * filter for address id
     * @summary get address id for office from database
     * @param {number} officeId Identifier for office
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficesApi
     */
    public getOfficesAddressId(officeId: number, options?: any) {
        return OfficesApiFp(this.configuration).getOfficesAddressId(officeId, options)(this.fetch, this.basePath);
    }

    /**
     * delete an existing office from the database via the office id
     * @summary delete an existing office from the database
     * @param {number} officeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficesApi
     */
    public officesDelete(officeId: number, options?: any) {
        return OfficesApiFp(this.configuration).officesDelete(officeId, options)(this.fetch, this.basePath);
    }

    /**
     * specify what office to manipulate via the identifier in the query and post the new office in the requestbody
     * @summary update an existing office in the database
     * @param {number} officeId 
     * @param {OfficesWithoutId} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficesApi
     */
    public officesPut(officeId: number, body?: OfficesWithoutId, options?: any) {
        return OfficesApiFp(this.configuration).officesPut(officeId, body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post an office to the database
     * @param {number} companyId 
     * @param {OfficesWithoutId} [body] the office that is to be inserted into the database, do NOT include the id in the request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficesApi
     */
    public postOffices(companyId: number, body?: OfficesWithoutId, options?: any) {
        return OfficesApiFp(this.configuration).postOffices(companyId, body, options)(this.fetch, this.basePath);
    }

}
/**
 * ParametersApi - fetch parameter creator
 * @export
 */
export const ParametersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete an existing parameter from the database via the parameter id
         * @summary delete existing default_parameters for a transport_type from the database
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultParametersDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling defaultParametersDelete.');
            }
            const localVarPath = `/parameters/default`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing default_parameter in the database
         * @param {ParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultParametersPut(body: ParametersWithId, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling defaultParametersPut.');
            }
            const localVarPath = `/parameters/default`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParametersWithId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get default_parameters from database
         * @param {number} [id] Identifier for default_parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameters(id?: number, options: any = {}): FetchArgs {
            const localVarPath = `/parameters/default`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get parameters from database
         * @param {number} [id] Identifier for parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameters(id?: number, options: any = {}): FetchArgs {
            const localVarPath = `/parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get parameters for a specific transportType from database
         * @param {string} transportType type of transport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParametersTransport(transportType: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportType' is not null or undefined
            if (transportType === null || transportType === undefined) {
                throw new RequiredError('transportType','Required parameter transportType was null or undefined when calling getParametersTransport.');
            }
            const localVarPath = `/parameters/transport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (transportType !== undefined) {
                localVarQueryParameter['transport_type'] = transportType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing parameter from the database via the parameter id
         * @summary delete existing parameters for a transport_type from the database
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parametersDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling parametersDelete.');
            }
            const localVarPath = `/parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing parameter in the database
         * @param {ParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parametersPut(body: ParametersWithId, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling parametersPut.');
            }
            const localVarPath = `/parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParametersWithId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post default_parameters for a new transport type to the database
         * @param {ParametersWithoutId} [body] the default_parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDefaultParameters(body?: ParametersWithoutId, options: any = {}): FetchArgs {
            const localVarPath = `/parameters/default`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParametersWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post parameters for a new transport type to the database
         * @param {ParametersWithoutId} [body] the parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameters(body?: ParametersWithoutId, options: any = {}): FetchArgs {
            const localVarPath = `/parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParametersWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParametersApi - functional programming interface
 * @export
 */
export const ParametersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * delete an existing parameter from the database via the parameter id
         * @summary delete existing default_parameters for a transport_type from the database
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultParametersDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).defaultParametersDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing default_parameter in the database
         * @param {ParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultParametersPut(body: ParametersWithId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).defaultParametersPut(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get default_parameters from database
         * @param {number} [id] Identifier for default_parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameters(id?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithoutId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).getDefaultParameters(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get parameters from database
         * @param {number} [id] Identifier for parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameters(id?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithoutId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).getParameters(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get parameters for a specific transportType from database
         * @param {string} transportType type of transport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParametersTransport(transportType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).getParametersTransport(transportType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * delete an existing parameter from the database via the parameter id
         * @summary delete existing parameters for a transport_type from the database
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parametersDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).parametersDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing parameter in the database
         * @param {ParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parametersPut(body: ParametersWithId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).parametersPut(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post default_parameters for a new transport type to the database
         * @param {ParametersWithoutId} [body] the default_parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDefaultParameters(body?: ParametersWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithoutId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).postDefaultParameters(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post parameters for a new transport type to the database
         * @param {ParametersWithoutId} [body] the parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameters(body?: ParametersWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParametersWithoutId> {
            const localVarFetchArgs = ParametersApiFetchParamCreator(configuration).postParameters(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ParametersApi - factory interface
 * @export
 */
export const ParametersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * delete an existing parameter from the database via the parameter id
         * @summary delete existing default_parameters for a transport_type from the database
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultParametersDelete(id: number, options?: any) {
            return ParametersApiFp(configuration).defaultParametersDelete(id, options)(fetch, basePath);
        },
        /**
         * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing default_parameter in the database
         * @param {ParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultParametersPut(body: ParametersWithId, options?: any) {
            return ParametersApiFp(configuration).defaultParametersPut(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get default_parameters from database
         * @param {number} [id] Identifier for default_parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameters(id?: number, options?: any) {
            return ParametersApiFp(configuration).getDefaultParameters(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get parameters from database
         * @param {number} [id] Identifier for parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameters(id?: number, options?: any) {
            return ParametersApiFp(configuration).getParameters(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get parameters for a specific transportType from database
         * @param {string} transportType type of transport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParametersTransport(transportType: string, options?: any) {
            return ParametersApiFp(configuration).getParametersTransport(transportType, options)(fetch, basePath);
        },
        /**
         * delete an existing parameter from the database via the parameter id
         * @summary delete existing parameters for a transport_type from the database
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parametersDelete(id: number, options?: any) {
            return ParametersApiFp(configuration).parametersDelete(id, options)(fetch, basePath);
        },
        /**
         * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
         * @summary manipulate an existing parameter in the database
         * @param {ParametersWithId} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parametersPut(body: ParametersWithId, options?: any) {
            return ParametersApiFp(configuration).parametersPut(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post default_parameters for a new transport type to the database
         * @param {ParametersWithoutId} [body] the default_parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDefaultParameters(body?: ParametersWithoutId, options?: any) {
            return ParametersApiFp(configuration).postDefaultParameters(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post parameters for a new transport type to the database
         * @param {ParametersWithoutId} [body] the parameters that are to be inserted into the database, do NOT include the id in the request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameters(body?: ParametersWithoutId, options?: any) {
            return ParametersApiFp(configuration).postParameters(body, options)(fetch, basePath);
        },
    };
};

/**
 * ParametersApi - object-oriented interface
 * @export
 * @class ParametersApi
 * @extends {BaseAPI}
 */
export class ParametersApi extends BaseAPI {
    /**
     * delete an existing parameter from the database via the parameter id
     * @summary delete existing default_parameters for a transport_type from the database
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public defaultParametersDelete(id: number, options?: any) {
        return ParametersApiFp(this.configuration).defaultParametersDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
     * @summary manipulate an existing default_parameter in the database
     * @param {ParametersWithId} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public defaultParametersPut(body: ParametersWithId, options?: any) {
        return ParametersApiFp(this.configuration).defaultParametersPut(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get default_parameters from database
     * @param {number} [id] Identifier for default_parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getDefaultParameters(id?: number, options?: any) {
        return ParametersApiFp(this.configuration).getDefaultParameters(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get parameters from database
     * @param {number} [id] Identifier for parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getParameters(id?: number, options?: any) {
        return ParametersApiFp(this.configuration).getParameters(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get parameters for a specific transportType from database
     * @param {string} transportType type of transport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getParametersTransport(transportType: string, options?: any) {
        return ParametersApiFp(this.configuration).getParametersTransport(transportType, options)(this.fetch, this.basePath);
    }

    /**
     * delete an existing parameter from the database via the parameter id
     * @summary delete existing parameters for a transport_type from the database
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public parametersDelete(id: number, options?: any) {
        return ParametersApiFp(this.configuration).parametersDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * specify what parameter to manipulate via the identifier in the query and post the new parameter in the requestbody
     * @summary manipulate an existing parameter in the database
     * @param {ParametersWithId} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public parametersPut(body: ParametersWithId, options?: any) {
        return ParametersApiFp(this.configuration).parametersPut(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post default_parameters for a new transport type to the database
     * @param {ParametersWithoutId} [body] the default_parameters that are to be inserted into the database, do NOT include the id in the request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public postDefaultParameters(body?: ParametersWithoutId, options?: any) {
        return ParametersApiFp(this.configuration).postDefaultParameters(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post parameters for a new transport type to the database
     * @param {ParametersWithoutId} [body] the parameters that are to be inserted into the database, do NOT include the id in the request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public postParameters(body?: ParametersWithoutId, options?: any) {
        return ParametersApiFp(this.configuration).postParameters(body, options)(this.fetch, this.basePath);
    }

}
/**
 * PathsApi - fetch parameter creator
 * @export
 */
export const PathsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * use the path ID of a loaded Object to delete it
         * @summary delete an existing path
         * @param {number} pathId Identifier used for paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePath(pathId: number, options: any = {}): FetchArgs {
            // verify required parameter 'pathId' is not null or undefined
            if (pathId === null || pathId === undefined) {
                throw new RequiredError('pathId','Required parameter pathId was null or undefined when calling deletePath.');
            }
            const localVarPath = `/paths`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pathId !== undefined) {
                localVarQueryParameter['pathId'] = pathId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete paths by ids array
         * @param {PathsOfficeBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePathByIds(body: PathsOfficeBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deletePathByIds.');
            }
            const localVarPath = `/paths/office`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PathsOfficeBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate and insert multiple paths for a specific destination and shift
         * @summary Bulk insert paths
         * @param {PathsBulkInsertBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndInsertPaths(body: PathsBulkInsertBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateAndInsertPaths.');
            }
            const localVarPath = `/paths/bulk_insert`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PathsBulkInsertBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filtering for postalcode and district possible
         * @summary get all paths used in a project.
         * @param {number} [projId] Identifier for projects
         * @param {string} [postalCode] 
         * @param {string} [district] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPath(projId?: number, postalCode?: string, district?: string, options: any = {}): FetchArgs {
            const localVarPath = `/paths/project`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postalCode'] = postalCode;
            }

            if (district !== undefined) {
                localVarQueryParameter['district'] = district;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method will take identifiers of a project, company and an office and will return the paths with no geo data.
         * @summary Returns paths belonging to an office that don't have geo data in origin or destination.
         * @param {number} projectId Identifier for projects
         * @param {number} companyId Identifier for companies
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathsWithEmptyGeo(projectId: number, companyId: number, officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new RequiredError('projectId','Required parameter projectId was null or undefined when calling getPathsWithEmptyGeo.');
            }
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getPathsWithEmptyGeo.');
            }
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getPathsWithEmptyGeo.');
            }
            const localVarPath = `/paths/geo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method will take an identifier of an existing office and will return the paths connected to this office. You can find the office-ids in the database or through making a HTTP-GET request to the /offices enpoint.
         * @summary Returns paths belonging to an office.
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathsWithOfficeId(officeId: number, options: any = {}): FetchArgs {
            // verify required parameter 'officeId' is not null or undefined
            if (officeId === null || officeId === undefined) {
                throw new RequiredError('officeId','Required parameter officeId was null or undefined when calling getPathsWithOfficeId.');
            }
            const localVarPath = `/paths/office`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post an individual path
         * @param {PathBody} body the path to be inserted into the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPath(body: PathBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postPath.');
            }
            const localVarPath = `/paths`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PathBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update an existing Path
         * @param {PathBodyPUT} body updated Path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPath(body: PathBodyPUT, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling putPath.');
            }
            const localVarPath = `/paths`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PathBodyPUT" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PathsApi - functional programming interface
 * @export
 */
export const PathsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * use the path ID of a loaded Object to delete it
         * @summary delete an existing path
         * @param {number} pathId Identifier used for paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePath(pathId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PathsBody> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).deletePath(pathId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary delete paths by ids array
         * @param {PathsOfficeBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePathByIds(body: PathsOfficeBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).deletePathByIds(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Generate and insert multiple paths for a specific destination and shift
         * @summary Bulk insert paths
         * @param {PathsBulkInsertBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndInsertPaths(body: PathsBulkInsertBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).generateAndInsertPaths(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Filtering for postalcode and district possible
         * @summary get all paths used in a project.
         * @param {number} [projId] Identifier for projects
         * @param {string} [postalCode] 
         * @param {string} [district] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPath(projId?: number, postalCode?: string, district?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PathWithId>> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).getPath(projId, postalCode, district, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This method will take identifiers of a project, company and an office and will return the paths with no geo data.
         * @summary Returns paths belonging to an office that don't have geo data in origin or destination.
         * @param {number} projectId Identifier for projects
         * @param {number} companyId Identifier for companies
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathsWithEmptyGeo(projectId: number, companyId: number, officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PathsViewWithoutGeo> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).getPathsWithEmptyGeo(projectId, companyId, officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This method will take an identifier of an existing office and will return the paths connected to this office. You can find the office-ids in the database or through making a HTTP-GET request to the /offices enpoint.
         * @summary Returns paths belonging to an office.
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathsWithOfficeId(officeId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PathsResponse> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).getPathsWithOfficeId(officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post an individual path
         * @param {PathBody} body the path to be inserted into the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPath(body: PathBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Path> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).postPath(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary update an existing Path
         * @param {PathBodyPUT} body updated Path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPath(body: PathBodyPUT, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PathsBody> {
            const localVarFetchArgs = PathsApiFetchParamCreator(configuration).putPath(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PathsApi - factory interface
 * @export
 */
export const PathsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * use the path ID of a loaded Object to delete it
         * @summary delete an existing path
         * @param {number} pathId Identifier used for paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePath(pathId: number, options?: any) {
            return PathsApiFp(configuration).deletePath(pathId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary delete paths by ids array
         * @param {PathsOfficeBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePathByIds(body: PathsOfficeBody, options?: any) {
            return PathsApiFp(configuration).deletePathByIds(body, options)(fetch, basePath);
        },
        /**
         * Generate and insert multiple paths for a specific destination and shift
         * @summary Bulk insert paths
         * @param {PathsBulkInsertBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndInsertPaths(body: PathsBulkInsertBody, options?: any) {
            return PathsApiFp(configuration).generateAndInsertPaths(body, options)(fetch, basePath);
        },
        /**
         * Filtering for postalcode and district possible
         * @summary get all paths used in a project.
         * @param {number} [projId] Identifier for projects
         * @param {string} [postalCode] 
         * @param {string} [district] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPath(projId?: number, postalCode?: string, district?: string, options?: any) {
            return PathsApiFp(configuration).getPath(projId, postalCode, district, options)(fetch, basePath);
        },
        /**
         * This method will take identifiers of a project, company and an office and will return the paths with no geo data.
         * @summary Returns paths belonging to an office that don't have geo data in origin or destination.
         * @param {number} projectId Identifier for projects
         * @param {number} companyId Identifier for companies
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathsWithEmptyGeo(projectId: number, companyId: number, officeId: number, options?: any) {
            return PathsApiFp(configuration).getPathsWithEmptyGeo(projectId, companyId, officeId, options)(fetch, basePath);
        },
        /**
         * This method will take an identifier of an existing office and will return the paths connected to this office. You can find the office-ids in the database or through making a HTTP-GET request to the /offices enpoint.
         * @summary Returns paths belonging to an office.
         * @param {number} officeId Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathsWithOfficeId(officeId: number, options?: any) {
            return PathsApiFp(configuration).getPathsWithOfficeId(officeId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post an individual path
         * @param {PathBody} body the path to be inserted into the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPath(body: PathBody, options?: any) {
            return PathsApiFp(configuration).postPath(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary update an existing Path
         * @param {PathBodyPUT} body updated Path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPath(body: PathBodyPUT, options?: any) {
            return PathsApiFp(configuration).putPath(body, options)(fetch, basePath);
        },
    };
};

/**
 * PathsApi - object-oriented interface
 * @export
 * @class PathsApi
 * @extends {BaseAPI}
 */
export class PathsApi extends BaseAPI {
    /**
     * use the path ID of a loaded Object to delete it
     * @summary delete an existing path
     * @param {number} pathId Identifier used for paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public deletePath(pathId: number, options?: any) {
        return PathsApiFp(this.configuration).deletePath(pathId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary delete paths by ids array
     * @param {PathsOfficeBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public deletePathByIds(body: PathsOfficeBody, options?: any) {
        return PathsApiFp(this.configuration).deletePathByIds(body, options)(this.fetch, this.basePath);
    }

    /**
     * Generate and insert multiple paths for a specific destination and shift
     * @summary Bulk insert paths
     * @param {PathsBulkInsertBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public generateAndInsertPaths(body: PathsBulkInsertBody, options?: any) {
        return PathsApiFp(this.configuration).generateAndInsertPaths(body, options)(this.fetch, this.basePath);
    }

    /**
     * Filtering for postalcode and district possible
     * @summary get all paths used in a project.
     * @param {number} [projId] Identifier for projects
     * @param {string} [postalCode] 
     * @param {string} [district] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public getPath(projId?: number, postalCode?: string, district?: string, options?: any) {
        return PathsApiFp(this.configuration).getPath(projId, postalCode, district, options)(this.fetch, this.basePath);
    }

    /**
     * This method will take identifiers of a project, company and an office and will return the paths with no geo data.
     * @summary Returns paths belonging to an office that don't have geo data in origin or destination.
     * @param {number} projectId Identifier for projects
     * @param {number} companyId Identifier for companies
     * @param {number} officeId Identifier for offices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public getPathsWithEmptyGeo(projectId: number, companyId: number, officeId: number, options?: any) {
        return PathsApiFp(this.configuration).getPathsWithEmptyGeo(projectId, companyId, officeId, options)(this.fetch, this.basePath);
    }

    /**
     * This method will take an identifier of an existing office and will return the paths connected to this office. You can find the office-ids in the database or through making a HTTP-GET request to the /offices enpoint.
     * @summary Returns paths belonging to an office.
     * @param {number} officeId Identifier for offices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public getPathsWithOfficeId(officeId: number, options?: any) {
        return PathsApiFp(this.configuration).getPathsWithOfficeId(officeId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post an individual path
     * @param {PathBody} body the path to be inserted into the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public postPath(body: PathBody, options?: any) {
        return PathsApiFp(this.configuration).postPath(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary update an existing Path
     * @param {PathBodyPUT} body updated Path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PathsApi
     */
    public putPath(body: PathBodyPUT, options?: any) {
        return PathsApiFp(this.configuration).putPath(body, options)(this.fetch, this.basePath);
    }

}
/**
 * PollApi - fetch parameter creator
 * @export
 */
export const PollApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Poll} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writePoll(body?: Poll, options: any = {}): FetchArgs {
            const localVarPath = `/poll`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'applicatin/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Poll" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PollApi - functional programming interface
 * @export
 */
export const PollApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Poll} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writePoll(body?: Poll, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StatusResponse> {
            const localVarFetchArgs = PollApiFetchParamCreator(configuration).writePoll(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PollApi - factory interface
 * @export
 */
export const PollApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Poll} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writePoll(body?: Poll, options?: any) {
            return PollApiFp(configuration).writePoll(body, options)(fetch, basePath);
        },
    };
};

/**
 * PollApi - object-oriented interface
 * @export
 * @class PollApi
 * @extends {BaseAPI}
 */
export class PollApi extends BaseAPI {
    /**
     * 
     * @param {Poll} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PollApi
     */
    public writePoll(body?: Poll, options?: any) {
        return PollApiFp(this.configuration).writePoll(body, options)(this.fetch, this.basePath);
    }

}
/**
 * PolygonsApi - fetch parameter creator
 * @export
 */
export const PolygonsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete an individual geopolygon.
         * @param {number} polyId Identifier used for geopolygons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolygon(polyId: number, options: any = {}): FetchArgs {
            // verify required parameter 'polyId' is not null or undefined
            if (polyId === null || polyId === undefined) {
                throw new RequiredError('polyId','Required parameter polyId was null or undefined when calling deletePolygon.');
            }
            const localVarPath = `/polygon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (polyId !== undefined) {
                localVarQueryParameter['polyId'] = polyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * filtering for polygontype and group is possible
         * @summary get all polygons from a project.
         * @param {number} [projId] Identifier for projects
         * @param {string} [polyType] type of polygon
         * @param {number} [polyGroup] geopolygons can be grouped for better datahandling (for instance one group for every map)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolygon(projId?: number, polyType?: string, polyGroup?: number, options: any = {}): FetchArgs {
            const localVarPath = `/polygon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            if (polyType !== undefined) {
                localVarQueryParameter['polyType'] = polyType;
            }

            if (polyGroup !== undefined) {
                localVarQueryParameter['polyGroup'] = polyGroup;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post a individual geographical polygon off any type
         * @param {GeoPolygon} body Geopolygon that should be inserted into the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPolygon(body: GeoPolygon, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postPolygon.');
            }
            const localVarPath = `/polygon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GeoPolygon" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update an existing geopolygon
         * @param {GeoPolygonWithId} body Geopolygon that should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPolygon(body: GeoPolygonWithId, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling putPolygon.');
            }
            const localVarPath = `/polygon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GeoPolygonWithId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolygonsApi - functional programming interface
 * @export
 */
export const PolygonsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete an individual geopolygon.
         * @param {number} polyId Identifier used for geopolygons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolygon(polyId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoPolygonWithId> {
            const localVarFetchArgs = PolygonsApiFetchParamCreator(configuration).deletePolygon(polyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * filtering for polygontype and group is possible
         * @summary get all polygons from a project.
         * @param {number} [projId] Identifier for projects
         * @param {string} [polyType] type of polygon
         * @param {number} [polyGroup] geopolygons can be grouped for better datahandling (for instance one group for every map)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolygon(projId?: number, polyType?: string, polyGroup?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GeoPolygonWithId>> {
            const localVarFetchArgs = PolygonsApiFetchParamCreator(configuration).getPolygon(projId, polyType, polyGroup, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post a individual geographical polygon off any type
         * @param {GeoPolygon} body Geopolygon that should be inserted into the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPolygon(body: GeoPolygon, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoPolygonWithId> {
            const localVarFetchArgs = PolygonsApiFetchParamCreator(configuration).postPolygon(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary update an existing geopolygon
         * @param {GeoPolygonWithId} body Geopolygon that should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPolygon(body: GeoPolygonWithId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoPolygonWithId> {
            const localVarFetchArgs = PolygonsApiFetchParamCreator(configuration).putPolygon(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PolygonsApi - factory interface
 * @export
 */
export const PolygonsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary delete an individual geopolygon.
         * @param {number} polyId Identifier used for geopolygons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolygon(polyId: number, options?: any) {
            return PolygonsApiFp(configuration).deletePolygon(polyId, options)(fetch, basePath);
        },
        /**
         * filtering for polygontype and group is possible
         * @summary get all polygons from a project.
         * @param {number} [projId] Identifier for projects
         * @param {string} [polyType] type of polygon
         * @param {number} [polyGroup] geopolygons can be grouped for better datahandling (for instance one group for every map)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolygon(projId?: number, polyType?: string, polyGroup?: number, options?: any) {
            return PolygonsApiFp(configuration).getPolygon(projId, polyType, polyGroup, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post a individual geographical polygon off any type
         * @param {GeoPolygon} body Geopolygon that should be inserted into the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPolygon(body: GeoPolygon, options?: any) {
            return PolygonsApiFp(configuration).postPolygon(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary update an existing geopolygon
         * @param {GeoPolygonWithId} body Geopolygon that should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPolygon(body: GeoPolygonWithId, options?: any) {
            return PolygonsApiFp(configuration).putPolygon(body, options)(fetch, basePath);
        },
    };
};

/**
 * PolygonsApi - object-oriented interface
 * @export
 * @class PolygonsApi
 * @extends {BaseAPI}
 */
export class PolygonsApi extends BaseAPI {
    /**
     * 
     * @summary delete an individual geopolygon.
     * @param {number} polyId Identifier used for geopolygons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public deletePolygon(polyId: number, options?: any) {
        return PolygonsApiFp(this.configuration).deletePolygon(polyId, options)(this.fetch, this.basePath);
    }

    /**
     * filtering for polygontype and group is possible
     * @summary get all polygons from a project.
     * @param {number} [projId] Identifier for projects
     * @param {string} [polyType] type of polygon
     * @param {number} [polyGroup] geopolygons can be grouped for better datahandling (for instance one group for every map)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public getPolygon(projId?: number, polyType?: string, polyGroup?: number, options?: any) {
        return PolygonsApiFp(this.configuration).getPolygon(projId, polyType, polyGroup, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post a individual geographical polygon off any type
     * @param {GeoPolygon} body Geopolygon that should be inserted into the database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public postPolygon(body: GeoPolygon, options?: any) {
        return PolygonsApiFp(this.configuration).postPolygon(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary update an existing geopolygon
     * @param {GeoPolygonWithId} body Geopolygon that should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public putPolygon(body: GeoPolygonWithId, options?: any) {
        return PolygonsApiFp(this.configuration).putPolygon(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ProjectsApi - fetch parameter creator
 * @export
 */
export const ProjectsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete an existing project
         * @param {number} projId identifier of existing project that should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(projId: number, options: any = {}): FetchArgs {
            // verify required parameter 'projId' is not null or undefined
            if (projId === null || projId === undefined) {
                throw new RequiredError('projId','Required parameter projId was null or undefined when calling deleteProject.');
            }
            const localVarPath = `/projects`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all projects in the database
         * @summary get all projects from database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options: any = {}): FetchArgs {
            const localVarPath = `/projects`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post an individual Project
         * @param {Project} body Project to be posted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProject(body: Project, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postProject.');
            }
            const localVarPath = `/projects`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Project" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * identifier has to be given
         * @summary manipulate an existing project
         * @param {Project} [body] new projectvalues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProject(body?: Project, options: any = {}): FetchArgs {
            const localVarPath = `/projects`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Project" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete an existing project
         * @param {number} projId identifier of existing project that should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(projId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Project> {
            const localVarFetchArgs = ProjectsApiFetchParamCreator(configuration).deleteProject(projId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get all projects in the database
         * @summary get all projects from database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Project> {
            const localVarFetchArgs = ProjectsApiFetchParamCreator(configuration).getProjects(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post an individual Project
         * @param {Project} body Project to be posted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProject(body: Project, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Project> {
            const localVarFetchArgs = ProjectsApiFetchParamCreator(configuration).postProject(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * identifier has to be given
         * @summary manipulate an existing project
         * @param {Project} [body] new projectvalues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProject(body?: Project, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Project> {
            const localVarFetchArgs = ProjectsApiFetchParamCreator(configuration).putProject(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary delete an existing project
         * @param {number} projId identifier of existing project that should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(projId: number, options?: any) {
            return ProjectsApiFp(configuration).deleteProject(projId, options)(fetch, basePath);
        },
        /**
         * get all projects in the database
         * @summary get all projects from database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options?: any) {
            return ProjectsApiFp(configuration).getProjects(options)(fetch, basePath);
        },
        /**
         * 
         * @summary post an individual Project
         * @param {Project} body Project to be posted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProject(body: Project, options?: any) {
            return ProjectsApiFp(configuration).postProject(body, options)(fetch, basePath);
        },
        /**
         * identifier has to be given
         * @summary manipulate an existing project
         * @param {Project} [body] new projectvalues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProject(body?: Project, options?: any) {
            return ProjectsApiFp(configuration).putProject(body, options)(fetch, basePath);
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @summary delete an existing project
     * @param {number} projId identifier of existing project that should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public deleteProject(projId: number, options?: any) {
        return ProjectsApiFp(this.configuration).deleteProject(projId, options)(this.fetch, this.basePath);
    }

    /**
     * get all projects in the database
     * @summary get all projects from database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjects(options?: any) {
        return ProjectsApiFp(this.configuration).getProjects(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post an individual Project
     * @param {Project} body Project to be posted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public postProject(body: Project, options?: any) {
        return ProjectsApiFp(this.configuration).postProject(body, options)(this.fetch, this.basePath);
    }

    /**
     * identifier has to be given
     * @summary manipulate an existing project
     * @param {Project} [body] new projectvalues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public putProject(body?: Project, options?: any) {
        return ProjectsApiFp(this.configuration).putProject(body, options)(this.fetch, this.basePath);
    }

}
/**
 * RoutesApi - fetch parameter creator
 * @export
 */
export const RoutesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete all existing route errors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllRouteErrors(options: any = {}): FetchArgs {
            const localVarPath = `/routes/errors`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get leg count for specific transport and path
         * @param {number} pathId 
         * @param {string} routeTransport 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegCountByTransport(pathId: number, routeTransport: string, options: any = {}): FetchArgs {
            // verify required parameter 'pathId' is not null or undefined
            if (pathId === null || pathId === undefined) {
                throw new RequiredError('pathId','Required parameter pathId was null or undefined when calling getLegCountByTransport.');
            }
            // verify required parameter 'routeTransport' is not null or undefined
            if (routeTransport === null || routeTransport === undefined) {
                throw new RequiredError('routeTransport','Required parameter routeTransport was null or undefined when calling getLegCountByTransport.');
            }
            const localVarPath = `/transport-chain/leg-count`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pathId !== undefined) {
                localVarQueryParameter['path_id'] = pathId;
            }

            if (routeTransport !== undefined) {
                localVarQueryParameter['route_transport'] = routeTransport;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all route errors for a given range of path ids
         * @param {number} pathIdFirst first path id of the range
         * @param {number} pathIdLast last path id of the range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteErrors(pathIdFirst: number, pathIdLast: number, options: any = {}): FetchArgs {
            // verify required parameter 'pathIdFirst' is not null or undefined
            if (pathIdFirst === null || pathIdFirst === undefined) {
                throw new RequiredError('pathIdFirst','Required parameter pathIdFirst was null or undefined when calling getRouteErrors.');
            }
            // verify required parameter 'pathIdLast' is not null or undefined
            if (pathIdLast === null || pathIdLast === undefined) {
                throw new RequiredError('pathIdLast','Required parameter pathIdLast was null or undefined when calling getRouteErrors.');
            }
            const localVarPath = `/routes/errors`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pathIdFirst !== undefined) {
                localVarQueryParameter['path_id_first'] = pathIdFirst;
            }

            if (pathIdLast !== undefined) {
                localVarQueryParameter['path_id_last'] = pathIdLast;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get route results
         * @param {number} [pathId] 
         * @param {number} [routeId] 
         * @param {string} [transportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteResults(pathId?: number, routeId?: number, transportId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/route_results`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pathId !== undefined) {
                localVarQueryParameter['path_id'] = pathId;
            }

            if (routeId !== undefined) {
                localVarQueryParameter['route_id'] = routeId;
            }

            if (transportId !== undefined) {
                localVarQueryParameter['transport_id'] = transportId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all routes that belong to a path
         * @param {number} [strId] Identifier for paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouten(strId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/routes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (strId !== undefined) {
                localVarQueryParameter['strId'] = strId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transport chain
         * @param {number} [pathId] 
         * @param {number} [routeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportChain(pathId?: number, routeId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/transport_chain`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pathId !== undefined) {
                localVarQueryParameter['path_id'] = pathId;
            }

            if (routeId !== undefined) {
                localVarQueryParameter['route_id'] = routeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post a route error
         * @param {RouteErrorWithoutId} body the route error that should be inserted into the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRouteError(body: RouteErrorWithoutId, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postRouteError.');
            }
            const localVarPath = `/routes/errors`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RouteErrorWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new route result
         * @param {RouteResults} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRouteResults(body: RouteResults, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postRouteResults.');
            }
            const localVarPath = `/route_results`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RouteResults" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new transport chain entry
         * @param {TransportChain} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransportChain(body: TransportChain, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postTransportChain.');
            }
            const localVarPath = `/transport_chain`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportChain" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoutesApi - functional programming interface
 * @export
 */
export const RoutesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete all existing route errors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllRouteErrors(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RouteErrorWithId> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).deleteAllRouteErrors(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get leg count for specific transport and path
         * @param {number} pathId 
         * @param {string} routeTransport 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegCountByTransport(pathId: number, routeTransport: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20020> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).getLegCountByTransport(pathId, routeTransport, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get all route errors for a given range of path ids
         * @param {number} pathIdFirst first path id of the range
         * @param {number} pathIdLast last path id of the range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteErrors(pathIdFirst: number, pathIdLast: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RouteErrorWithId>> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).getRouteErrors(pathIdFirst, pathIdLast, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get route results
         * @param {number} [pathId] 
         * @param {number} [routeId] 
         * @param {string} [transportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteResults(pathId?: number, routeId?: number, transportId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RouteResults> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).getRouteResults(pathId, routeId, transportId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get all routes that belong to a path
         * @param {number} [strId] Identifier for paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouten(strId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Route>> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).getRouten(strId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get transport chain
         * @param {number} [pathId] 
         * @param {number} [routeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportChain(pathId?: number, routeId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportChain> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).getTransportChain(pathId, routeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary post a route error
         * @param {RouteErrorWithoutId} body the route error that should be inserted into the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRouteError(body: RouteErrorWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RouteErrorWithId> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).postRouteError(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create a new route result
         * @param {RouteResults} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRouteResults(body: RouteResults, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RouteResults> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).postRouteResults(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create a new transport chain entry
         * @param {TransportChain} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransportChain(body: TransportChain, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportChain> {
            const localVarFetchArgs = RoutesApiFetchParamCreator(configuration).postTransportChain(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RoutesApi - factory interface
 * @export
 */
export const RoutesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary delete all existing route errors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllRouteErrors(options?: any) {
            return RoutesApiFp(configuration).deleteAllRouteErrors(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get leg count for specific transport and path
         * @param {number} pathId 
         * @param {string} routeTransport 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegCountByTransport(pathId: number, routeTransport: string, options?: any) {
            return RoutesApiFp(configuration).getLegCountByTransport(pathId, routeTransport, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get all route errors for a given range of path ids
         * @param {number} pathIdFirst first path id of the range
         * @param {number} pathIdLast last path id of the range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteErrors(pathIdFirst: number, pathIdLast: number, options?: any) {
            return RoutesApiFp(configuration).getRouteErrors(pathIdFirst, pathIdLast, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get route results
         * @param {number} [pathId] 
         * @param {number} [routeId] 
         * @param {string} [transportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteResults(pathId?: number, routeId?: number, transportId?: string, options?: any) {
            return RoutesApiFp(configuration).getRouteResults(pathId, routeId, transportId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get all routes that belong to a path
         * @param {number} [strId] Identifier for paths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouten(strId?: number, options?: any) {
            return RoutesApiFp(configuration).getRouten(strId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get transport chain
         * @param {number} [pathId] 
         * @param {number} [routeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportChain(pathId?: number, routeId?: number, options?: any) {
            return RoutesApiFp(configuration).getTransportChain(pathId, routeId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary post a route error
         * @param {RouteErrorWithoutId} body the route error that should be inserted into the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRouteError(body: RouteErrorWithoutId, options?: any) {
            return RoutesApiFp(configuration).postRouteError(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create a new route result
         * @param {RouteResults} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRouteResults(body: RouteResults, options?: any) {
            return RoutesApiFp(configuration).postRouteResults(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create a new transport chain entry
         * @param {TransportChain} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransportChain(body: TransportChain, options?: any) {
            return RoutesApiFp(configuration).postTransportChain(body, options)(fetch, basePath);
        },
    };
};

/**
 * RoutesApi - object-oriented interface
 * @export
 * @class RoutesApi
 * @extends {BaseAPI}
 */
export class RoutesApi extends BaseAPI {
    /**
     * 
     * @summary delete all existing route errors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public deleteAllRouteErrors(options?: any) {
        return RoutesApiFp(this.configuration).deleteAllRouteErrors(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get leg count for specific transport and path
     * @param {number} pathId 
     * @param {string} routeTransport 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getLegCountByTransport(pathId: number, routeTransport: string, options?: any) {
        return RoutesApiFp(this.configuration).getLegCountByTransport(pathId, routeTransport, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get all route errors for a given range of path ids
     * @param {number} pathIdFirst first path id of the range
     * @param {number} pathIdLast last path id of the range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getRouteErrors(pathIdFirst: number, pathIdLast: number, options?: any) {
        return RoutesApiFp(this.configuration).getRouteErrors(pathIdFirst, pathIdLast, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get route results
     * @param {number} [pathId] 
     * @param {number} [routeId] 
     * @param {string} [transportId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getRouteResults(pathId?: number, routeId?: number, transportId?: string, options?: any) {
        return RoutesApiFp(this.configuration).getRouteResults(pathId, routeId, transportId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get all routes that belong to a path
     * @param {number} [strId] Identifier for paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getRouten(strId?: number, options?: any) {
        return RoutesApiFp(this.configuration).getRouten(strId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get transport chain
     * @param {number} [pathId] 
     * @param {number} [routeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getTransportChain(pathId?: number, routeId?: number, options?: any) {
        return RoutesApiFp(this.configuration).getTransportChain(pathId, routeId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary post a route error
     * @param {RouteErrorWithoutId} body the route error that should be inserted into the database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public postRouteError(body: RouteErrorWithoutId, options?: any) {
        return RoutesApiFp(this.configuration).postRouteError(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create a new route result
     * @param {RouteResults} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public postRouteResults(body: RouteResults, options?: any) {
        return RoutesApiFp(this.configuration).postRouteResults(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create a new transport chain entry
     * @param {TransportChain} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public postTransportChain(body: TransportChain, options?: any) {
        return RoutesApiFp(this.configuration).postTransportChain(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ShiftsApi - fetch parameter creator
 * @export
 */
export const ShiftsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete an existing shift from the database (give id of a shift in the query)
         * @summary delete an existing shift from the database
         * @param {number} shiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShifts(shiftId: number, options: any = {}): FetchArgs {
            // verify required parameter 'shiftId' is not null or undefined
            if (shiftId === null || shiftId === undefined) {
                throw new RequiredError('shiftId','Required parameter shiftId was null or undefined when calling deleteShifts.');
            }
            const localVarPath = `/shifts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (shiftId !== undefined) {
                localVarQueryParameter['ShiftId'] = shiftId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get shifts from database
         * @summary get shifts
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShifts(officeId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/shifts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * use the office id in query to connect the shift to a office
         * @summary post a new shift to the database
         * @param {ShiftWithoutId} [body] please give the time like so: HH:MM:SS
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShifts(body?: ShiftWithoutId, officeId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/shifts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShiftWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * specify what shift you want to manipulate through the shift id given in the query
         * @summary manipulate a existing shift
         * @param {number} shiftId 
         * @param {ShiftWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putShifts(shiftId: number, body?: ShiftWithoutId, options: any = {}): FetchArgs {
            // verify required parameter 'shiftId' is not null or undefined
            if (shiftId === null || shiftId === undefined) {
                throw new RequiredError('shiftId','Required parameter shiftId was null or undefined when calling putShifts.');
            }
            const localVarPath = `/shifts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (shiftId !== undefined) {
                localVarQueryParameter['ShiftId'] = shiftId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShiftWithoutId" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShiftsApi - functional programming interface
 * @export
 */
export const ShiftsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * delete an existing shift from the database (give id of a shift in the query)
         * @summary delete an existing shift from the database
         * @param {number} shiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShifts(shiftId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Shift> {
            const localVarFetchArgs = ShiftsApiFetchParamCreator(configuration).deleteShifts(shiftId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get shifts from database
         * @summary get shifts
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShifts(officeId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Shift>> {
            const localVarFetchArgs = ShiftsApiFetchParamCreator(configuration).getShifts(officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * use the office id in query to connect the shift to a office
         * @summary post a new shift to the database
         * @param {ShiftWithoutId} [body] please give the time like so: HH:MM:SS
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShifts(body?: ShiftWithoutId, officeId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShiftWithoutId> {
            const localVarFetchArgs = ShiftsApiFetchParamCreator(configuration).postShifts(body, officeId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * specify what shift you want to manipulate through the shift id given in the query
         * @summary manipulate a existing shift
         * @param {number} shiftId 
         * @param {ShiftWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putShifts(shiftId: number, body?: ShiftWithoutId, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShiftWithoutId> {
            const localVarFetchArgs = ShiftsApiFetchParamCreator(configuration).putShifts(shiftId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ShiftsApi - factory interface
 * @export
 */
export const ShiftsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * delete an existing shift from the database (give id of a shift in the query)
         * @summary delete an existing shift from the database
         * @param {number} shiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShifts(shiftId: number, options?: any) {
            return ShiftsApiFp(configuration).deleteShifts(shiftId, options)(fetch, basePath);
        },
        /**
         * get shifts from database
         * @summary get shifts
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShifts(officeId?: number, options?: any) {
            return ShiftsApiFp(configuration).getShifts(officeId, options)(fetch, basePath);
        },
        /**
         * use the office id in query to connect the shift to a office
         * @summary post a new shift to the database
         * @param {ShiftWithoutId} [body] please give the time like so: HH:MM:SS
         * @param {number} [officeId] Identifier for offices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShifts(body?: ShiftWithoutId, officeId?: number, options?: any) {
            return ShiftsApiFp(configuration).postShifts(body, officeId, options)(fetch, basePath);
        },
        /**
         * specify what shift you want to manipulate through the shift id given in the query
         * @summary manipulate a existing shift
         * @param {number} shiftId 
         * @param {ShiftWithoutId} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putShifts(shiftId: number, body?: ShiftWithoutId, options?: any) {
            return ShiftsApiFp(configuration).putShifts(shiftId, body, options)(fetch, basePath);
        },
    };
};

/**
 * ShiftsApi - object-oriented interface
 * @export
 * @class ShiftsApi
 * @extends {BaseAPI}
 */
export class ShiftsApi extends BaseAPI {
    /**
     * delete an existing shift from the database (give id of a shift in the query)
     * @summary delete an existing shift from the database
     * @param {number} shiftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApi
     */
    public deleteShifts(shiftId: number, options?: any) {
        return ShiftsApiFp(this.configuration).deleteShifts(shiftId, options)(this.fetch, this.basePath);
    }

    /**
     * get shifts from database
     * @summary get shifts
     * @param {number} [officeId] Identifier for offices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApi
     */
    public getShifts(officeId?: number, options?: any) {
        return ShiftsApiFp(this.configuration).getShifts(officeId, options)(this.fetch, this.basePath);
    }

    /**
     * use the office id in query to connect the shift to a office
     * @summary post a new shift to the database
     * @param {ShiftWithoutId} [body] please give the time like so: HH:MM:SS
     * @param {number} [officeId] Identifier for offices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApi
     */
    public postShifts(body?: ShiftWithoutId, officeId?: number, options?: any) {
        return ShiftsApiFp(this.configuration).postShifts(body, officeId, options)(this.fetch, this.basePath);
    }

    /**
     * specify what shift you want to manipulate through the shift id given in the query
     * @summary manipulate a existing shift
     * @param {number} shiftId 
     * @param {ShiftWithoutId} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApi
     */
    public putShifts(shiftId: number, body?: ShiftWithoutId, options?: any) {
        return ShiftsApiFp(this.configuration).putShifts(shiftId, body, options)(this.fetch, this.basePath);
    }

}
/**
 * StatusApi - fetch parameter creator
 * @export
 */
export const StatusApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get authentication status for debugging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthStatus(options: any = {}): FetchArgs {
            const localVarPath = `/auth-status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusApi - functional programming interface
 * @export
 */
export const StatusApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get authentication status for debugging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthStatus(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StatusApiFetchParamCreator(configuration).getAuthStatus(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StatusApi - factory interface
 * @export
 */
export const StatusApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get authentication status for debugging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthStatus(options?: any) {
            return StatusApiFp(configuration).getAuthStatus(options)(fetch, basePath);
        },
    };
};

/**
 * StatusApi - object-oriented interface
 * @export
 * @class StatusApi
 * @extends {BaseAPI}
 */
export class StatusApi extends BaseAPI {
    /**
     * 
     * @summary Get authentication status for debugging
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    public getAuthStatus(options?: any) {
        return StatusApiFp(this.configuration).getAuthStatus(options)(this.fetch, this.basePath);
    }

}
/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete a project-user-relation
         * @param {number} projId Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectUserRelation(projId: number, options: any = {}): FetchArgs {
            // verify required parameter 'projId' is not null or undefined
            if (projId === null || projId === undefined) {
                throw new RequiredError('projId','Required parameter projId was null or undefined when calling deleteProjectUserRelation.');
            }
            const localVarPath = `/user/usersOfProject`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get additional profile data of user (profile-photo, user-role, user-scopes)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData(options: any = {}): FetchArgs {
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all users of a project
         * @param {number} [projId] Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfProject(projId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/user/usersOfProject`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (projId !== undefined) {
                localVarQueryParameter['projId'] = projId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary invite user to a project
         * @param {UserProjectRelation} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserToProject(body: UserProjectRelation, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling inviteUserToProject.');
            }
            const localVarPath = `/user/inviteToProject`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserProjectRelation" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete a project-user-relation
         * @param {number} projId Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectUserRelation(projId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20014> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).deleteProjectUserRelation(projId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get additional profile data of user (profile-photo, user-role, user-scopes)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).getUserData(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get all users of a project
         * @param {number} [projId] Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfProject(projId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<UserProjectRelation>> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).getUsersOfProject(projId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary invite user to a project
         * @param {UserProjectRelation} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserToProject(body: UserProjectRelation, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2007> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).inviteUserToProject(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary delete a project-user-relation
         * @param {number} projId Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectUserRelation(projId: number, options?: any) {
            return UserApiFp(configuration).deleteProjectUserRelation(projId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get additional profile data of user (profile-photo, user-role, user-scopes)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData(options?: any) {
            return UserApiFp(configuration).getUserData(options)(fetch, basePath);
        },
        /**
         * 
         * @summary get all users of a project
         * @param {number} [projId] Identifier for projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfProject(projId?: number, options?: any) {
            return UserApiFp(configuration).getUsersOfProject(projId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary invite user to a project
         * @param {UserProjectRelation} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserToProject(body: UserProjectRelation, options?: any) {
            return UserApiFp(configuration).inviteUserToProject(body, options)(fetch, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary delete a project-user-relation
     * @param {number} projId Identifier for projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteProjectUserRelation(projId: number, options?: any) {
        return UserApiFp(this.configuration).deleteProjectUserRelation(projId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get additional profile data of user (profile-photo, user-role, user-scopes)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserData(options?: any) {
        return UserApiFp(this.configuration).getUserData(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get all users of a project
     * @param {number} [projId] Identifier for projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUsersOfProject(projId?: number, options?: any) {
        return UserApiFp(this.configuration).getUsersOfProject(projId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary invite user to a project
     * @param {UserProjectRelation} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public inviteUserToProject(body: UserProjectRelation, options?: any) {
        return UserApiFp(this.configuration).inviteUserToProject(body, options)(this.fetch, this.basePath);
    }

}
/**
 * UserCompanyApi - fetch parameter creator
 * @export
 */
export const UserCompanyApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete user company relation
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserCompany(companyId: number, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling deleteUserCompany.');
            }
            const localVarPath = `/user_company`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user company relation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompany(options: any = {}): FetchArgs {
            const localVarPath = `/user_company`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserCompanyApi - functional programming interface
 * @export
 */
export const UserCompanyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete user company relation
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserCompany(companyId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserCompanyResponse> {
            const localVarFetchArgs = UserCompanyApiFetchParamCreator(configuration).deleteUserCompany(companyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user company relation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompany(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserCompanyResponse> {
            const localVarFetchArgs = UserCompanyApiFetchParamCreator(configuration).getUserCompany(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserCompanyApi - factory interface
 * @export
 */
export const UserCompanyApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Delete user company relation
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserCompany(companyId: number, options?: any) {
            return UserCompanyApiFp(configuration).deleteUserCompany(companyId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user company relation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompany(options?: any) {
            return UserCompanyApiFp(configuration).getUserCompany(options)(fetch, basePath);
        },
    };
};

/**
 * UserCompanyApi - object-oriented interface
 * @export
 * @class UserCompanyApi
 * @extends {BaseAPI}
 */
export class UserCompanyApi extends BaseAPI {
    /**
     * 
     * @summary Delete user company relation
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCompanyApi
     */
    public deleteUserCompany(companyId: number, options?: any) {
        return UserCompanyApiFp(this.configuration).deleteUserCompany(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user company relation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCompanyApi
     */
    public getUserCompany(options?: any) {
        return UserCompanyApiFp(this.configuration).getUserCompany(options)(this.fetch, this.basePath);
    }

}
/**
 * ZipcodesApi - fetch parameter creator
 * @export
 */
export const ZipcodesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve zip code areas based on a list of zip codes
         * @summary Get zip code areas
         * @param {ZipcodesBody} body Array of 5-digit German postal codes to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZipcodes(body: ZipcodesBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getZipcodes.');
            }
            const localVarPath = `/zipcodes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication myOAuth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("myOAuth2", ["spec-data:read", "spec-data:write", "gen-data:read", "gen-data:write", "project:read", "project:write"])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ZipcodesBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZipcodesApi - functional programming interface
 * @export
 */
export const ZipcodesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieve zip code areas based on a list of zip codes
         * @summary Get zip code areas
         * @param {ZipcodesBody} body Array of 5-digit German postal codes to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZipcodes(body: ZipcodesBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ZipcodeResponse> {
            const localVarFetchArgs = ZipcodesApiFetchParamCreator(configuration).getZipcodes(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ZipcodesApi - factory interface
 * @export
 */
export const ZipcodesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Retrieve zip code areas based on a list of zip codes
         * @summary Get zip code areas
         * @param {ZipcodesBody} body Array of 5-digit German postal codes to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZipcodes(body: ZipcodesBody, options?: any) {
            return ZipcodesApiFp(configuration).getZipcodes(body, options)(fetch, basePath);
        },
    };
};

/**
 * ZipcodesApi - object-oriented interface
 * @export
 * @class ZipcodesApi
 * @extends {BaseAPI}
 */
export class ZipcodesApi extends BaseAPI {
    /**
     * Retrieve zip code areas based on a list of zip codes
     * @summary Get zip code areas
     * @param {ZipcodesBody} body Array of 5-digit German postal codes to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesApi
     */
    public getZipcodes(body: ZipcodesBody, options?: any) {
        return ZipcodesApiFp(this.configuration).getZipcodes(body, options)(this.fetch, this.basePath);
    }

}
